<template>
  <div>
    <div v-if="isUnderMaintenance == 0 || isUnderMaintenance == 1">
      <app-toolbar :toolbar="toolbar"></app-toolbar>

      <planners-table ></planners-table>
    
      <!-- Dialogs -->
      <!-- SECTION : PLANNER BASIC INFO -->
      <v-dialog v-model="dialogStore" max-width="1000" persistent>
        <div class="text-center" style="font-family: Sans-serif">
          <center>
            <v-overlay v-model="overlay">
              <v-progress-circular indeterminate :size="120" :width="3">
              </v-progress-circular
              >Loading,please wait...
            </v-overlay>
          </center>
        </div>
        <div class="text-center" style="font-family: Sans-serif">
          <center>
            <v-overlay v-model="$store.state.overlayMain">
              <v-progress-circular indeterminate :size="120" :width="3">
              </v-progress-circular
              >Downloading,please wait...
            </v-overlay>
          </center>
        </div>
        <v-form id="Store" ref="Store" @submit.prevent="Store" >
          <v-card :loading="cardLoader">
            <template slot="progress">
              <v-progress-linear color="primary" indeterminate></v-progress-linear>
            </template>
            <v-card-title>
              <div class="headline"> 基本情報 </div>
              <v-spacer></v-spacer>
              <!-- <v-icon dark  @click="closeDialogStore()">mdi-close</v-icon> -->
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <template>
                    <v-col cols="6">
                        <!-- @input="formatCustomerCode" -->
                        <!-- @change="checkIfExisting" -->

                    <v-text-field
                      @input="formatCustomerCode"
                      v-model="tempData.customer_code"
                      v-if="
                        loggedInUser.is_admin == 1 ||
                        loggedInUser.is_hrd_requestor == 1 ||
                        loggedInUser.plan_control == 1 ||
                        loggedInUser.japan_admin == 1
                      "
                      :append-icon="tempData.customer_code || tempData.customer_code == '' ? 'mdi-close' : ''"
                      @click:append="clearForm()"
                      dense
                      outlined
                      label="お客様コード"
                      class="required"
                      counter="12"
                      maxlength="12"
                      :disabled="disabledcustomercode"
                      @compositionstart="imeStarted"
                      @compositionend="imeEnded"
                    ></v-text-field>
                    <!-- ONLY PLANNER PLANS IN CRS -->
                    <!-- <v-combobox
                      @input="filteredPlanControlNumber"
                      v-else
                      v-model="tempData.customer_code"
                      :items="tempData.customer_code && tempData.customer_code.length === 2 ? getPlan : plannerControlNumber"
                      item-value="customer_code"
                      item-text="customer_code"
                      @change="checkIfExisting(tempData.customer_code)"
                      @click:clear="clearForm()"
                      disable-lookup
                      clearable
                      name="customer_code"
                      label="お客様コード"
                      :return-object="false"
                      outlined
                      dense
                      class="required"
                      counter="12"
                      maxlength="12"
                      :disabled="disabledcustomercode"
                    >
                      <template v-slot:item="{ item }">
                        <div>{{ item.customer_code }} {{ item.customer_name }}</div>
                      </template>
                    </v-combobox> -->
                    <v-combobox
                      @keyup="handleKeyUp"
                      @change="handleChange"
                      ref="codeRef"
                      v-else
                      v-model="tempData.customer_code"
                      :items="tempData.customer_code ? getPlan : plannerControlNumber"
                      item-value="customer_code"
                      item-text="customer_code"
                      @click:clear="clearForm()"
                      disable-lookup
                      clearable
                      name="customer_code"
                      label="お客様コード"
                      :return-object="false"
                      outlined
                      dense
                      class="required"
                      counter="12"
                      maxlength="12"
                      :disabled="disabledcustomercode"
                      @compositionstart="imeStarted"
                      @compositionend="imeEnded"
                    >
                      <template v-slot:item="{ item }">
                        <div>{{ item.customer_code }} {{ item.customer_name }}</div>
                      </template>
                    </v-combobox>
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="tempData.house_type_id"
                      name="house_type_id"
                      label="建物タイプ"
                      outlined
                      dense
                      class="required"
                      :items="HOUSE_TYPES"
                      item-text="name"
                      item-value="id"
                      :rules="rules.required"
                      :loading="tempData.loading"
                      :disabled="disabled"
                      @input="getHouseGroup()"

                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12">
                      <v-autocomplete
                        v-model="tempData.remarks"
                        name="remarks"
                        label="備考欄"
                        outlined
                        dense
                        :items="sortRemarks"
                        item-text="remark"
                        item-value="remark_id"
                        multiple
                        :loading="tempData.loading"
                        :disabled="disabled"
                        hide-details
                      >
                        <template v-slot:selection="{ item }">
                          <!-- {{item}} -->
                          <v-chip v-if="item.remark_id == 18">
                            <span>{{ item.remark }}&nbsp;</span>
                            <!-- <span>{{ tempData.remarks[index].gc_control_number }}</span> -->
                            <span>{{ tempData.gc_control_number }}</span>
                          </v-chip>
                          <v-chip v-else-if="item.remark_id == 22">
                            <span>{{ item.remark }}&nbsp;</span>
                            <span>{{ tempData.snow }}</span>
                          </v-chip>
                          <v-chip v-else>
                            <span>{{ item.remark }}&nbsp;</span>
                          </v-chip>
                        </template>
                        <template v-slot:item="{ item }">
                          <div>
                            <span>{{ item.remark }}</span>
                            <v-text-field
                              label="直営またはGC側の物件コード"
                              height="5px"
                              class="custom-text-field"
                              v-if="item.remark_id == 18"
                              outlined
                              dense
                              hide-details
                              v-model="tempData.gc_control_number"
                            ></v-text-field>
                            <v-text-field
                              label="〇〇〇"
                              height="4px"
                              class="custom-text-field"
                              v-if="item.remark_id == 22"
                              outlined
                              dense
                              hide-details
                              v-model="tempData.snow"
                            ></v-text-field>
                          </div>
                        </template>
                      </v-autocomplete>

                      <!-- <v-autocomplete
                      v-model="tempData.remarks"
                      name="remarks"
                      label="備考欄"
                      outlined
                      dense
                      :items="REMARKS"
                      item-text="name"
                      item-value="id"
                      multiple
                      :loading="tempData.loading"
                      :disabled="disabled"
                      @change="openDialog()"
                    ></v-autocomplete> -->
                    </v-col>

                    <!-- SECTION: DYNAMIC FIELDS -->
                    <!--  
                    GROUP 1 - 'i-smart', 'GRAND SMART', 'i-cube'
                  -->
                    <template>
                      <v-col cols="6" class="mt-3">
                        <v-autocomplete
                          v-if="showGroup.fire_protection == '1'"
                          v-model="tempData.fire_protection"
                          name="fire_protection"
                          :loading="tempData.loading"
                          :items="getFireProtection"
                          item-value="value"
                          item-text="text"
                          dense
                          outlined
                          label="防火仕様"
                          class="required"
                          :rules="rules.required"
                          :background-color="tempData.fire_protection == '' || tempData.fire_protection == null ? '#fffec8' : 'white'"
                          :disabled="disabled"
                        >
                        </v-autocomplete>
                      </v-col>

                      <v-col cols="6" class="mt-3">
                        <v-autocomplete
                          v-if="showGroup.heavy_snow == '1'"
                          v-model="heavySnowValue"
                          name="heavy_snow"
                          :items="ariNashi"
                          item-value="value"
                          item-text="text"
                          dense
                          outlined
                          label="建物仕様(枠組) : 豪雪仕様"
                        >
                        </v-autocomplete>
                        <!-- <v-checkbox
                          v-if="showGroup.heavy_snow == '1'"
                          label="建物仕様(枠組) : 豪雪仕様"
                          v-model="tempData.heavy_snow"
                          name="heavy_snow"
                          :disabled="disabled"
                          value="1"
                        ></v-checkbox> -->
                      </v-col>

                      <v-col cols="6">
                        <v-autocomplete
                          v-if="showGroup.kanabakari == '1'"
                          v-model="tempData.rectangle_meter"
                          name="rectangle_meter"
                          :items="kanaSetting"
                          dense
                          outlined
                          label="矩計"
                          class="required"
                          :background-color="tempData.rectangle_meter == '' || tempData.rectangle_meter == null ? '#fffec8' : 'white'"
                          :rules="rules.required"
                          :loading="tempData.loading"
                          :disabled="disabled"
                        >
                        </v-autocomplete>
                      </v-col>

                      <!-- NOTE - ORIGINAL CODE 11/25/25 -->
                      <!-- <v-col cols="6">
                        <v-autocomplete
                          v-if="showGroup.water_tight == '1'"
                          v-model="tempData.water_tight"
                          name="water_tight"
                          :loading="tempData.loading"
                          :items="tempData.house_type_id === 10 ? ['なし', '耐水害（ｽﾀﾝﾀﾞｰﾄﾞ)'] : ['なし', '耐水害（ｽﾀﾝﾀﾞｰﾄﾞ)', '耐水害（浮上)']"
                          class="required"
                          :rules="rules.required"
                          dense
                          outlined
                          label="耐水害住宅"
                          :disabled="disabled"
                          :background-color="tempData.water_tight == '' || tempData.water_tight == null ? '#fffec8' : 'white'"
                        > -->
                          <!-- :background-color="tempData.water_tight == '' || tempData.water_tight == null ? '##fffd8d' : 'white'"  // naka comment na talaga ito -->
                        <!-- </v-autocomplete>
                        
                      </v-col> -->

                      <!-- NOTE - SSD25-1121783-2399 MODIFIED 11/25/25 -->
                      <v-col cols="6" >
                        <v-autocomplete
                          v-show="showGroup"
                          v-model="tempData.water_tight"
                          name="water_tight"
                          :loading="tempData.loading"
                          :items="tempData.house_type_id === 10 ? ['なし', '耐水害（ｽﾀﾝﾀﾞｰﾄﾞ)', '耐水害 (床下)'] : [8, 9, 11, 12, 26, 27].includes(tempData.house_type_id) ? ['なし', '耐水害 (床下)'] : ['なし', '耐水害（ｽﾀﾝﾀﾞｰﾄﾞ)', '耐水害（浮上)', '耐水害 (床下)']"
                          class="required"
                          :rules="rules.required"
                          dense
                          outlined
                          label="耐水害住宅"
                          :disabled="disabled"
                          :background-color="tempData.water_tight == '' || tempData.water_tight == null ? '#fffec8' : 'white'"
                          @change="floodResistantMessage(tempData.water_tight)"
                        >
                          <!-- :background-color="tempData.water_tight == '' || tempData.water_tight == null ? '##fffd8d' : 'white'"   // nakacomment na talaga ito -->
                        </v-autocomplete>
                      </v-col>

                      <v-col cols="6">
                        <v-autocomplete
                          v-if="showGroup.earth_quake_resistance == '1'"
                          v-model="tempData.double_earthquake_resistance"
                          name="double_earthquake_resistance"
                          :loading="tempData.loading"
                          :items="ariNashi"
                          item-value="value"
                          item-text="text"
                          dense
                          outlined
                          label="２倍耐震"
                          class="required"
                          :rules="rules.required"
                          :disabled="disabled"
                          :background-color="tempData.double_earthquake_resistance == '' || tempData.double_earthquake_resistance == null ? '#fffec8' : 'white'"
                        >
                        </v-autocomplete>
                      </v-col>

                      <v-col cols="6">
                        <v-autocomplete
                          v-if="showGroup.high_fire_proof_outer_wall == '1'"
                          v-model="tempData.high_fireproof_outer_wall"
                          name="high_fireproof_outer_wall"
                          :loading="tempData.loading"
                          :items="ariNashi"
                          item-value="value"
                          item-text="text"
                          dense
                          outlined
                          label="高防火外壁"
                          class="required"
                          :rules="rules.required"
                          :disabled="disabled"
                          :background-color="tempData.high_fireproof_outer_wall == '' || tempData.high_fireproof_outer_wall == null ? '#fffec8' : 'white'"
                        >
                        </v-autocomplete>
                      </v-col>

                      <!-- SEISMIC ISOLATION -->
                      <v-col cols="6">
                        <v-autocomplete
                          v-if="showGroup.seismic_isolation == '1'"
                          v-model="tempData.seismic_isolation"
                          name="seismic_isolation"
                          :items="ariNashi"
                          item-value="value"
                          item-text="text"
                          dense
                          outlined
                          label="免震"
                          class="required"
                          :rules="rules.required"
                          :disabled="disabled"
                          :background-color="tempData.seismic_isolation == '' || tempData.seismic_isolation == null ? '#fffec8' : 'white'"
                        >
                        </v-autocomplete>
                      </v-col>

                      <v-col cols="6"></v-col>
                    </template>

                    <!--  
                    GROUP 2 - 'HUGme', 'i-smile', 'i-smile＋'
                  -->
                    <!-- <template v-else-if="GROUP_2.includes(getSelectedHouseType())">
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="tempData.fire_protection"
                        name="fire_protection"
                        :loading="tempData.loading"
                        :items="fireProtectionList"
                        item-value="value"
                        item-text="text"
                        dense
                        outlined
                        label="防火仕様"
                        class="required"
                        :rules="rules.required"
                        :disabled="disabled"
                      >
                      </v-autocomplete>
                    </v-col>

                    <v-col  cols="6">
                      <v-checkbox 
                        label="建物仕様(枠組) : 豪雪仕様" 
                        v-model="tempData.heavy_snow" 
                        name="heavy_snow"
                        :disabled="disabled"
                        value="1"
                      ></v-checkbox>
                    </v-col>

                    <v-col cols="6">
                      <v-autocomplete
                        v-model="tempData.rectangle_meter"
                        name="rectangle_meter"
                        :items="['240']"
                        dense
                        outlined
                        label="矩計"
                        class="required"
                        :rules="rules.required"
                        :loading="tempData.loading"
                        :disabled="disabled"
                      >
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="6">
                      <v-autocomplete
                        v-model="tempData.water_tight"
                        name="water_tight"
                        :loading="tempData.loading"
                        :items="['耐水害（ｽﾀﾝﾀﾞｰﾄﾞ)']"
                        dense
                        outlined
                        label="耐水害住宅"
                        :disabled="disabled"
                      >
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="6">
                      <v-autocomplete
                        v-model="tempData.double_earthquake_resistance"
                        name="double_earthquake_resistance"
                        :loading="tempData.loading"
                        :items="ariNashi"
                        item-value="value"
                        item-text="text"
                        dense
                        outlined
                        label="２倍耐震"
                        class="required"
                        :rules="rules.required"
                        :disabled="disabled"
                      >
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="6">
                      <v-autocomplete
                        v-model="tempData.high_fireproof_outer_wall"
                        name="high_fireproof_outer_wall"
                        :loading="tempData.loading"
                        :items="ariNashi"
                        item-value="value"
                        item-text="text"
                        dense
                        outlined
                        label="高防火外壁"
                        class="required"
                        :rules="rules.required"
                        :disabled="disabled"
                      >
                      </v-autocomplete>
                    </v-col>
                  </template> -->

                    <!--  
                    GROUP 3 - 'i-palette'
                  -->
                    <!-- <template v-else-if="GROUP_3.includes(getSelectedHouseType())">
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="tempData.fire_protection"
                        name="fire_protection"
                        :loading="tempData.loading"
                        :items="fireProtectionList"
                        item-value="value"
                        item-text="text"
                        dense
                        outlined
                        label="防火仕様"
                        class="required"
                        :rules="rules.required"
                        :disabled="disabled"
                      >
                      </v-autocomplete>
                    </v-col>

                    <v-col  cols="6">
                      <v-checkbox 
                        label="建物仕様(枠組) : 豪雪仕様" 
                        v-model="tempData.heavy_snow" 
                        name="heavy_snow"
                        :disabled="disabled"
                        value="1"
                      ></v-checkbox>
                    </v-col>

                    <v-col cols="6">
                      <v-autocomplete
                        v-model="tempData.rectangle_meter"
                        name="rectangle_meter"
                        :items="['240']"
                        dense
                        outlined
                        label="矩計"
                        class="required"
                        :rules="rules.required"
                        :loading="tempData.loading"
                        :disabled="disabled"
                      >
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="6">
                    </v-col>

                  </template> -->

                    <!--  
                    GROUP 4 - 'セゾンF', 'セゾンA', 'グラン･セゾン', 'ブリアール', '和風百年F'
                  -->
                    <!-- <template v-else-if="GROUP_4.includes(getSelectedHouseType())">
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="tempData.fire_protection"
                        name="fire_protection"
                        :loading="tempData.loading"
                        :items="fireProtectionList"
                        item-value="value"
                        item-text="text"
                        dense
                        outlined
                        label="防火仕様"
                        class="required"
                        :rules="rules.required"
                        :disabled="disabled"
                      >
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="6">
                      <v-autocomplete
                        v-model="tempData.rectangle_meter"
                        name="rectangle_meter"
                        :items="['240', '265']"
                        dense
                        outlined
                        label="矩計"
                        class="required"
                        :rules="rules.required"
                        :loading="tempData.loading"
                        :disabled="disabled"
                      >
                      </v-autocomplete>
                    </v-col>
                  </template> -->
                    <!-- !SECTION: DYNAMIC FIELDS -->

                    <v-col cols="3">
                      <v-text-field
                        v-model="tempData.expected_house_raising_date"
                        name="expected_house_raising_date"
                        :loading="tempData.loading"
                        label="上棟予定日"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </v-col>

                    <v-col cols="3">
                      <v-text-field
                        v-model="tempData.sent_process_request_date"
                        name="sent_process_request_date"
                        :loading="tempData.loading"
                        label=" 加工依頼日"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </v-col>

                    <v-col cols="3">
                      <v-text-field
                        v-if="tempData.provisional_contract_date != null"
                        v-model="tempData.provisional_contract_date"
                        name="provisional_contract_date"
                        :loading="tempData.loading"
                        label="仮契約日"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                      <v-menu
                          v-else
                          v-model="tempData.dateFromMenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="tempData.provisional_contract_date_manual"
                                name="provisional_contract_date_manual"
                                :loading="tempData.loading"
                                label="仮契約日"
                                v-bind="attrs"
                                v-on="on"
                                outlined
                                dense
                                hide-details
                                readonly
                              ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="tempData.provisional_contract_date_manual"
                              @input="dateFromMenu = false">
                          </v-date-picker>
                      </v-menu>
                      
                    </v-col>

                    <!-- <v-col cols="3">
                      <v-text-field
                        v-model="tempData.provisional_contract_date"
                        name="provisional_contract_date"
                        :loading="tempData.loading"
                        label="仮契約日"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </v-col> -->

                    <v-col cols="3">
                      <v-text-field
                        v-model="tempData.contract_date"
                        name="contract_date"
                        :loading="tempData.loading"
                        label="本契約日"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </v-col>

                    <!-- <v-col cols="12" class="mt-2">
                      <v-divider> </v-divider>
                    </v-col> -->
                    <v-col cols="12">
                      <span class="overline font-weight-black">敷地情報</span>
                    </v-col>
                    <template id="siteInformation">
                      <v-col cols="4">
                        <v-autocomplete
                          v-model="tempData.site_address_prefecture_code"
                          name="site_address_prefecture_code"
                          :loading="tempData.loading"
                          label="建築地"
                          outlined
                          dense
                          :items="PREFECTURES"
                          item-text="prefecture_name"
                          item-value="prefecture_code"
                          class="required"
                          :rules="rules.required"
                          @input="getPrefectureCode(tempData.site_address_prefecture_code)"
                          :background-color="tempData.site_address_prefecture_code == '' || tempData.site_address_prefecture_code == null ? '#fffec8' : 'white'"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          v-model="tempData.site_address_prefecture_code"
                          name="site_address_prefecture_code"
                          :loading="tempData.loading"
                          label="県コード"
                          outlined
                          dense
                          readonly
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-autocomplete
                          v-model="tempData.power_company_name"
                          name="power_company_name"
                          :loading="tempData.loading"
                          label="電力会社名"
                          outlined
                          dense
                          :items="ELECTRIC_COMPANY"
                          item-text="electric_company"
                          item-value="electric_company"
                          class="required"
                          :rules="rules.required"
                          :background-color="tempData.power_company_name == '' || tempData.power_company_name == null ? '#fffec8' : 'white'"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          v-model="tempData.vertical_snow_cover"
                          name="vertical_snow_cover"
                          :loading="tempData.loading"
                          label="垂直積雪量"
                          outlined
                          dense
                          suffix="cm"
                          class="required"
                          :rules="rules.required"
                          :background-color="tempData.vertical_snow_cover == '' || tempData.vertical_snow_cover == null ? '#fffec8' : 'white' "
                          @input="handleInputKanji"
                        ></v-text-field>
                          <!-- @input="handleInputKanji" -->
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          v-model="tempData.reference_wind_velocity"
                          name="reference_wind_velocity"
                          :loading="tempData.loading"
                          label="基準風速"
                          outlined
                          dense
                          suffix="m/s"
                          class="required"
                          :rules="rules.required"
                          :background-color="tempData.reference_wind_velocity == '' || tempData.reference_wind_velocity == null ? '#fffec8' : 'white' "
                          @input="handleInputKanji"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-combobox
                          v-model="tempData.distance_from_shore"
                          @input="handleInput(tempData.distance_from_shore)"
                          name="distance_from_shore"
                          :loading="tempData.loading"
                          label="海岸からの距離"
                          :items="['∞']"
                          outlined
                          dense
                          suffix="km"
                          class="required"
                          :rules="rules.required"
                          :background-color="tempData.distance_from_shore == '' || tempData.distance_from_shore == null ? '#fffec8' : 'white'"
                        ></v-combobox>
                      </v-col>
                      <v-col cols="4">
                        <v-autocomplete
                          v-model="tempData.snow_classification"
                          name="snow_classification"
                          :loading="tempData.loading"
                          label="積雪区分"
                          :items="['一般地域', '多雪区域内']"
                          outlined
                          dense
                          class="required"
                          :rules="rules.required"
                          @change="checkInsuRestriction"
                          :background-color="tempData.snow_classification == '' || tempData.snow_classification == null ? '#fffec8' : 'white'"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="tempData.grade_insulation"
                          :items="insulationItems"
                          name="grade_insulation"
                          dense
                          outlined
                          label="省エネ地域区分"
                          :loading="tempData.loading"
                          class="required"
                          :rules="rules.required"
                          @change="checkInsuRestriction"
                          :background-color="tempData.grade_insulation == '' || tempData.grade_insulation == null ? '#fffec8' : 'white'"
                          :disabled="!!ThermoAreaType"
                        >
                        </v-select>
                      </v-col>
                    </template>
                  </template>
                </v-row>
              </v-container>

              <v-card
                flat
                v-show="
                  (cadRequestBasicInformation.sent_process_request_date != null && cadRequestBasicInformation.sent_process_request_date != 0) ||
                  (tempData.sent_process_request_date != null && tempData.sent_process_request_date != 0) 
                "
              >
                <div>
                  <span class="text-h6">注意！</span>
                </div>
                <div>
                  <span
                    >特別CAD依頼をしただけでは、追加変更をした事
                    にはなりません。修正後の図面を添付の上、追加変更申請を行って下さい。</span
                  >
                </div>
                <hr />
                <v-card-text>
                  <span>以下のいずれかにチェックを必ず入れてください。</span>
                  <div>
                    <template>
                      <v-container class="px-0" fluid>
                        <v-radio-group v-model="tempData.kakouirai_reason">
                          <v-radio
                            v-for="(item, index) in kakouiraiReasons"
                            :key="index"
                            :label="item.text"
                            :value="item.value"
                          ></v-radio>
                        </v-radio-group>
                      </v-container>
                    </template>
                  </div>
                </v-card-text>
              </v-card>

              <v-snackbar
                class="custom-snackbar"
                v-model="snackbar.show"
                :color="snackbar.color"
                :multi-line="snackbar.mode === 'multi-line'"
                centered
                :timeout="snackTimeout"
                elevation="5"
                transition="scroll-y-transition"
              >
                <v-layout align-center pr-4>
                  <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
                  <v-layout column>
                    <div>
                      <strong>{{ snackbar.title }}</strong>
                    </div>
                    <div>
                      {{ snackbar.text }}
                    </div>
                  </v-layout>
                </v-layout>
              </v-snackbar>

              <v-snackbar
                class="custom-snackbar"
                v-model="requiredSnackbar.show"
                :color="requiredSnackbar.color"
                centered
                :timeout="snackTimeout"
                elevation="5"
                transition="scroll-y-transition"
              >
                <v-icon>{{ requiredSnackbar.icon }}</v-icon>
                <strong>{{ requiredSnackbar.message }}</strong>
              </v-snackbar>
            </v-card-text>
            <v-card-actions class="mr-1">
              <!-- <div> -->
                <v-spacer></v-spacer>
                <v-btn small dark color="red" type="submit" :disabled="validateForm">
                キャンセル
                </v-btn>
                <v-btn
                  class="mb-1"
                  small
                  dark
                  color="success"
                  type="submit"
                  width="8%"
                  :disabled="toggleCadDisable"
                  @click="clearStore()"
                >
                  保存
                </v-btn>
              <!-- </div> -->
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <!-- !SECTION : PLANNER BASIC INFO -->

      <app-buttons
        @toggleDialogStore="toggleDialogStore"
        :floatButtons="floatButtons"
        @generatePDF="generatePDF"
        @generatePiraPDF="generatePiraPDF"
      >
      </app-buttons>
    </div>

    <!-- NOTE - REQUEST CODE SSD25-0227783-2028(2025/03/28) -->
        <!-- SYSTEM UNDERMAINTENANCE MESSAGE -->
      <div v-if="isUnderMaintenance == 2" class="centered-div">
          <v-card height="300px" width="800px" elevation="0">
              <v-card-text class="d-flex justify-center align-center" style="height: 100%;">
                  <div class="text-center">
                      <h1 style="color: #A6AEBF">システムメンテナンス中</h1>
                      <br />
                      <h1 style="color: #A6AEBF" class="ma-3">下記時間帯はシステムの使用ができません。</h1>
                      <h1 style="color: #A6AEBF" class="ma-3">{{japanDate}} {{japanTime}}（日本時間）</h1>
                      <h1 style="color: #A6AEBF" class="ma-3">※{{philippineTime}}（フィリピン時間）</h1>
                  </div>
              </v-card-text>
          </v-card>
      </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState, mapActions } from "vuex";
import ToolbarMenu from "../modules/ToolbarMenu.vue";
import FloatingButtons from "../modules/FloatingButtons.vue";
import PlannersTable from "../components/PlannersTable.vue";
import Swal from 'sweetalert2';
import Vue from "vue";
export default {
  components: {
    "app-toolbar": ToolbarMenu,
    "app-buttons": FloatingButtons,
    "planners-table": PlannersTable,
  },

  sockets: {
    // NOTE : SOCKET
    updateReceived: function (socket) {
      // console.log('socket.dispatchType', socket.dispatchType)
      // console.log('this.env.response', this.env.response)
      // console.log('this.env.request', this.env.request)
      // console.log('socket.uniqId', socket.uniqId)
      // console.log('this.loggedInUser.uniqId', this.loggedInUser.uniqId)
      //if (socket && socket.dispatchType == 'response-local' ) {
      if (socket && socket.dispatchType == this.env.response && socket.uniqId == this.loggedInUser.uniqId && socket.functionType == "updateData") {
        let HRD_DATA = socket.data.outputData;
        // console.log(d'socket.data.outputData', socket.data.outputData)
        this.$set(this.tempData, "loading", false); // > this.tempDate.loading = false;
        this.disabled = false;
        this.transferToTempData(HRD_DATA);
        // this.cardLoader = socket.data.outputData.ConstructionName ? false : true
        // this.toggleCadDisable = socket.data.outputData.ConstructionName ? false : true
        this.toggleCadDisable = false
        this.cardLoader = false
      }
      if (socket && socket.dispatchType == this.env.response) {
        // if (socket.functionType == "plan-data") { // Real time getting of plans but it will affect all the planner, kasi mag loload ulit ng plano para sa ibang planner
          // if (socket.data.plans) {
          //   this.$store.state.plannerControlNumber = socket.data.plans.map((r) => {
          //     if (r.ConstructionName) {
          //       if (r.ConstructionName.includes(" ")) {
          //         r.ConstructionName = r.ConstructionName.split(" ")[0] + " 様邸";
          //       } else if (r.ConstructionName.includes("　")) {
          //         r.ConstructionName = r.ConstructionName.split("　")[0] + " 様邸";
          //       } else {
          //         r.ConstructionName = r.ConstructionName + " 様邸";
          //       }
          //     }
          //     return r;
          //   });
          //   this.$store.state.plannerControlNumber.sort(
          //     (a, b) =>
          //       parseInt(a.ConstructionCode.split("-")[0]) -
          //       parseInt(b.ConstructionCode.split("-")[0])
          //   );
          // }
        // } 
        if(socket.functionType == 'sent_process' && socket.uniqId == this.loggedInUser.uniqId){
          // console.log(socket,'outputtt')
          if (socket.data.customer_code && this.tempData.customer_code && socket.data.customer_code != this.tempData.customer_code) return
          this.tempData.expected_house_raising_date = !socket.data.outputData.expected_house_raising_date ? null : socket.data.outputData.expected_house_raising_date.slice(0, 10);
          this.tempData.sent_process_request_date = !socket.data.outputData.sent_process_request_date ? null : socket.data.outputData.sent_process_request_date.slice(0, 10);
          this.tempData.contract_date = !socket.data.outputData.contract_date ? null : socket.data.outputData.contract_date.slice(0, 10);
          this.tempData.provisional_contract_date = !socket.data.outputData.provisional_contract_date ? null : socket.data.outputData.provisional_contract_date.slice(0, 10);
          this.tempData.customer_name = socket.data.outputData.customer_name ? socket.data.outputData.customer_name.split(/　| /)[0] : null
          this.tempData.grade_insulation = socket.data.outputData.grade_insulation && socket.data.outputData.grade_insulation != '0' ? socket.data.outputData.grade_insulation : this.tempData.grade_insulation
          this.ThermoAreaType = socket.data.outputData.grade_insulation && socket.data.outputData.grade_insulation != '0' ? socket.data.outputData.grade_insulation : null
          // this.tempData.ConstructionName = socket.data.outputData.ConstructionName ? socket.data.outputData.ConstructionName.split(/　| /)[0] : null
          // this.$store.state.cadRequestBasicInformation.customer_name = socket.data.outputData.customer_name ? socket.data.outputData.customer_name.split(/　| /)[0] : null
          // this.toggleCadDisable = socket.data.outputData.customer_name ? false : true
          // this.cardLoader = socket.data.outputData.customer_name ? false : true
          this.toggleCadDisable = false
          this.cardLoader = false
        
        // --> MANUAL INPUTTING OF TEMP CONTRACT DATE
        if(socket.data.outputData.provisional_contract_date != null || this.tempData.dateFrom != null){
          this.tempData.provisional_contract_date = !socket.data.outputData.provisional_contract_date ? null : socket.data.outputData.provisional_contract_date.slice(0, 10);
        } else {
          this.tempData.dateFrom = this.tempData.dateFrom != null ? this.tempData.dateFrom : null;
        }

        //NOTE : TASETSU
        // let TasetsuArea = this.tempData.HeavySnowArea;
        // this.tempData.snow_classification = TasetsuArea == 0 ? null : TasetsuArea == 1 ? '多雪区域内' : TasetsuArea == 2 ? '一般地域' : null;
          // console.log(socket.data,'sock')
        }
      }
      // --------- GET AUTHORITY API RESPONSE ---------
      if(socket && socket.dispatchType == this.env.response && socket.functionType == 'getRestriction' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/cadrequest'){
        if(socket.data.outputAuth == 1 || socket.data.outputAuth == 2 || this.loggedInUser.type == 'Admin' || this.loggedInUser.type == 'HRD Requestor' || this.loggedInUser.type == 'Plan Control') {
          this.$store.state.authorityResponse = this.loggedInUser.type == 'Admin' ? 2 : socket.data.outputAuth
          this.toggleCadRequestData();
          this.arrangeHouseType();
        }else{
          // alert(socket.data.errorMessage || '指定したお客様コードの情報が取得出来ません。')
          Swal.fire({
            html: '<div style="text-align: center;font-size:26px;font-weight:bold;">' +
                '指定したお客様コードの情報が取得出来ません。',
            icon: 'warning',
            width : 630,
          }).then(() =>{
            this.clearForm()
          });
        }
        clearTimeout(this.authorityTimer)
      }

      // if(socket.function == 'download file to hrdapps72' && window.location.host == 'hrdapps72'){

      // }
    },
  },

  data() {
    return {
      envDB: process.env.MIX_DB_DATABASE,
      isUnderMaintenance: null,
      japanDate: '',
      japanTime: '',
      philippineTime: '',
      getPlan: [],
      getSiyo: null,
      getSnow: null,
      snackbar: {
        show: false,
        text: null,
        color: null,
        icon: null,
        mode: null,
        title: null,
      },
      dateFrom : '',
      dateFromMenu : false,
      requiredSnackbar: {
        show: false,
        color: null,
        icon: null,
        message: null,
      },
      snackTimeout: 4000,
      kanaSetting: [],
      sortKanabakari: [],
      sortRemarks: [],
      sortHouse: [],
      sortedHouseType: [],
      showGroup: "",
      overlay: true,
      disabledcustomercode: true,
      toolbar: {
        title: "  CAD依頼内容  ",
        view: false,
        back: false,
        filter: false,
        master: true,
      },

      floatButtons: {
        add: true,
        update: false,
        delete: false,
        cadPdf: false,
        piraPdf: false,
      },
      kakouiraiReasons: [
        { text: "追加変更（TH)", value: 1 },
        { text: "加工ストップ後追加変更申請で対応（TH)", value: 2 },
        { text: "加工ストップ後再加工依頼で対応 (RE-ORDER)", value: 3 },
        { text: "長期物件・再加工依頼（RE-ORDER)", value: 4 },
        { text: "参考プラン作成（OTHERS）", value: 5 }, // Additional button for kakouirai plans
        // {text : 'お引渡し後変更 (REFORM)', value: 5},
      ],
      // kakouRadio : null,
      // plannerControlNumber : [
      // 	{
      // 		customerCode : null,
      // 		customerCodeSurname : null,
      // 	}

      // ],
      //temp data storage
      tempData: {},
      dialogStore: false,
      dialogUpdate: false,
      dialogDelete: false,

      timeout: null,
      getFireProtection : [],
      fireProtectionList: [
        { value: "1", text: "なし" },
        { value: "2", text: "準防火仕様" },
        { value: "3", text: "準耐火仕様" },
      ],
      disabled: true,
      ariNashi: [
        { value: "1", text: "あり" },
        { value: "0", text: "なし" },
      ],
      ELECTRIC_COMPANIES: [
        { id: "1", name: "未定" },
        { id: "2", name: "北海道電力" },
        { id: "3", name: "東北電力" },
        { id: "4", name: "東京電力" },
        { id: "5", name: "北陸電力" },
        { id: "6", name: "中部電力" },
        { id: "7", name: "関西電力" },
        { id: "8", name: "中国電力" },
        { id: "9", name: "四国電力" },
        { id: "10", name: "九州電力" },
        { id: "11", name: "沖縄電力" },
      ],

      GROUP_1: ["i-smart", "GRAND SMART", "i-cube", "GRAND SMART(グラン･スマート)"],
      GROUP_2: ["HUGme", "i-smile", "i-smile＋"],
      GROUP_3: ["i-palette"],
      GROUP_4: ["セゾンF", "セゾンA", "グラン･セゾン", "ブリアール", "和風百年F"],

      filterGroup: [],
      filterStore: [],

      env: {
        response: process.env.MIX_ENV == "local" ? "response-local" : "response",
        request: process.env.MIX_ENV == "local" ? "request-local" : "request",
      },

      selectedItems: [],
      counts: [],
      softdeleteTriggered : false,
      getSentProcess : null,

      toggleCadDisable : true,
      cardLoader : false,

      authorityTimer: null,

      ThermoAreaType: null // need this for disabling the input select
    };
  },

  beforeCreate() {
    // Execute your function or perform any necessary operations here
    // This function will be called before the component is created

    // if(this.$store.state.loggedInUser.is_admin != 1 && this.$store.state.loggedInUser.is_special_account != 1){
    // 	fetch(`https://wedmpnam4d.execute-api.ap-southeast-1.amazonaws.com/prod/api/getInchargeCodes2Erica/${this.$store.state.loggedInUser.user_id}`, {
    // 		method: 'GET',
    // 		headers: {
    // 				'x-api-key': ''
    // 			}
    // 		}).then(response => {
    // 			if (!response.ok) {
    // 				throw new Error('Network response was not ok');
    // 			}
    // 				return response.json(); // Parse the JSON response
    // 		}).then(data => {
    // 			// Handle the data returned from the API
    // 			// console.log('API Response:', data);
    // 			// this.$store.state.plannerControlNumber = data[0]
    // 			if(data[0]){
    // 				this.$store.state.plannerControlNumber = data[0].map((r) => {
    // 					if(r.ConstructionName){
    // 						if(r.ConstructionName.includes(" ")){
    // 							r.ConstructionName = r.ConstructionName.split(" ")[0] + ' 様邸';
    // 						}else if(r.ConstructionName.includes("　")){
    // 							r.ConstructionName = r.ConstructionName.split("　")[0] + ' 様邸';
    // 						}else{
    // 							r.ConstructionName = r.ConstructionName + ' 様邸';
    // 						}
    // 					}
    // 					return r;
    // 				})

    // 				this.$store.state.plannerControlNumber.sort((a,b) => parseInt(a.ConstructionCode.split("-")[0]) - parseInt(b.ConstructionCode.split("-")[0]));
    // 			}
    // 			// You can process and use the data here
    // 		})
    // 		.catch(error => {
    // 			console.error('Error fetching data from API:', error);
    // 		});
    // }

    return;

    axios({
      method: "POST",
      url: "api/getPlannerPlans",
      data: {
        loggedInUser: this.$store.state.loggedInUser,
      },
    }).then(({ data }) => {
      this.selectedItems = data;
      this.$store.state.plannerControlNumber = data.map((r) => {
        if (r.customer_name) {
          if (r.customer_name.includes(" ")) {
            r.customer_name = r.customer_name.split(" ")[0] + " 様邸";
          } else if (r.customer_name.includes("　")) {
            r.customer_name = r.customer_name.split("　")[0] + " 様邸";
          } else {
            r.customer_name = r.customer_name + " 様邸";
          }
        }
        // console.log(r.length,'rrr')
        return r;
      });
      
    });
  },

  computed: {
    ...mapState([
      "viewMode",
      "rules",
      "REMARKS",
      "PREFECTURES",
      "cadRequestData",
      "HOUSE_TYPES",
      "HOUSE_TYPE_GROUPS",
      "KANABAKARI_SETTINGS",
      "HOUSE_TYPE_REMARKS",
      "ELECTRIC_COMPANY",
      "cadRequestBasicInformation",
      "loggedInUser",
      "existingRevisions",
      "actualButton",
      "draftButton",
      "deleteButton",
      "customerCodeFromView",
      "plannerControlNumber",
      "cadRequestVersion",
      "kakou_reason",
      "cadRequestBasicInformationRemarks",
      "editMode"
    ]),
  
    // toggleCadDisable() {
    //   return Object.keys(this.tempData).length > 6 ? false : true; 
    //   // return this.$store.state.authorityResponse ? false : true
    // //   const modelsToCheck = [
    // //   this.tempData.fire_protection,
    // //   this.tempData.high_fireproof_outer_wall,
    // //   this.tempData.double_earthquake_resistance,
    // //   this.tempData.seismic_isolation,
    // //   this.tempData.water_tight,
    // //   this.tempData.rectangle_meter,
    // //   this.tempData.site_address_prefecture_code,
    // //   this.tempData.power_company_name,
    // //   this.tempData.vertical_snow_cover,
    // //   this.tempData.reference_wind_velocity,
    // //   this.tempData.distance_from_shore,
    // //   this.tempData.snow_classification,
    // // ];

    // // // return modelsToCheck.some(model => model === null || model === '');
    // },
    heavySnowValue: {
      get() {
        return this.tempData.heavy_snow || '0';  // return the default value if tempData.heavy_snow is null or undefined
      },
      set(value) {
        this.tempData.heavy_snow = value;  // update the original property when the value changes
      }
    },

    validateForm() {
      if (
        this.GROUP_1.includes(this.getSelectedHouseType()) ||
        this.GROUP_2.includes(this.getSelectedHouseType())
      ) {
        if (
          !this.tempData.customer_code ||
          !this.tempData.house_type_id ||
          !this.tempData.site_address_prefecture_code ||
          !this.tempData.site_address_prefecture_name ||
          !this.tempData.power_company_name ||
          !this.tempData.vertical_snow_cover ||
          !this.tempData.reference_wind_velocity ||
          !this.tempData.distance_from_shore ||
          !this.tempData.snow_classification ||
          !this.tempData.fire_protection ||
          !this.tempData.rectangle_meter ||
          !this.tempData.double_earthquake_resistance ||
          !this.tempData.high_fireproof_outer_wall
        ) {
          return true;
        } else {
          return false;
        }
      } else if (
        this.GROUP_3.includes(this.getSelectedHouseType()) ||
        this.GROUP_4.includes(this.getSelectedHouseType())
      ) {
        if (
          !this.tempData.customer_code ||
          !this.tempData.house_type_id ||
          !this.tempData.site_address_prefecture_code ||
          !this.tempData.site_address_prefecture_name ||
          !this.tempData.power_company_name ||
          !this.tempData.vertical_snow_cover ||
          !this.tempData.reference_wind_velocity ||
          !this.tempData.distance_from_shore ||
          !this.tempData.snow_classification ||
          !this.tempData.fire_protection ||
          !this.tempData.rectangle_meter
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },

    insulationItems() {
      // const restrictedIds = [37, 38, 39]
      // const isDisabled = restrictedIds.includes(Number(this.tempData.house_type_id))
      // return ['1', '2', '3', '4', '5', '6', '7'].map(item => {
      //   return {
      //     text: item,
      //     value: item,
      //     disabled: isDisabled && (item === '6' || item === '7')
      //   }
      // })

      // NEW RULE: NO MORE RESTRICTION
      return ['1', '2', '3', '4', '5', '6', '7']
    },

    // REMOVED DUE TO NEW RULE: NO MORE RESTRICTION 
    // isInsulationRestricted() {
    //   const { house_type_id, grade_insulation, vertical_snow_cover, snow_classification } = this.tempData
    //   const restrictedHouseIds = [37, 38, 39]
    //   const grade = Number(grade_insulation)

    //   if (!restrictedHouseIds.includes(Number(house_type_id))) return false

    //   const isHighGradeRestricted = [6, 7].includes(grade)

    //   const isGrade5Restricted = grade === 5 && vertical_snow_cover < 100 && snow_classification === "一般地域"

    //   return isHighGradeRestricted || isGrade5Restricted
    // }
  },
  methods: {
    ...mapActions([
      "_getRemarks",
      "_getPrefectures",
      "_getHouseTypes",
      "setCadRequestBasicInformation",
      "getCadRequestBasicInformation",
      "cadRequestVer",
      "_getHouseTypeGroups",
      "_getKanabakari",
      "_getHouseTypeRemarks",
      "getUpdatedVersion",
      "_getCadBasicInforRemarks",
      "_getElectricCompanyName",
    ]),

    clearStore(){
      this.$store.state.cadRequestRevisionContent = {
                revision: null,
                design_contract: false,
                calculation_basis: false,
                site_layout: null,
                gravity_type: null,
                gravity : null,
                isHrdCpn: null,
                kakouirai_reason : null,
                site_layout_option: null,
                site_diagram: null,
                new_site_diagram: null,
                specs_irai: { 
                    sash_type: null,  
                    specs: null,  
                    accessories: [],
                    honeycomb: null,  
                },
                dxf_data_request: null,
                color_pers: null,
                house_presentation: null,
                house_presentation_int : null,
                shio_request: null,
                SRS_request: {
                    shio_selection: null,
                    shio_number: null,
                },
                web_documents: null,
                jiban_plan: null,
                alvs: null,
                status: null,
                structural_request: null,
                pdr: null,
                denki_gravity: null,
                // electrical_drawing: null,
                electrical_drawing: {
                    OPTION_1: null,
                    OPTION_2: null,
                    denki_plan_title: null,
                    radioGravity: null,
                    radioPdr: null,
                    selectedDrawing: [],
                },
                cross_section: null,
                elevation_section: null,
                stop: null,
                final_plan: null,
                express: null,
                request_attach_from: null,
                stopListSelection: null,
            };
            // this.$refs.dialogElectricalDrawing.closetoggleDialogElectricalDrawing();
            this.$store.state.cadRequestColorPers = [];
            this.$store.state.cad_request_house_presentation = [];
            // this.$store.state.cad_request_house_presentation_int = [];
            this.$store.state.attachments = [];
            this.$store.state.hideColorPersTable = null;
            this.$store.state.hideHpTable = null;
            
            this.$store.state.cadRequestLatestRevision = null;
            // this.toggleB5 = null;
            // this.toggleB6_1 = null;
            // this.toggleB6_2 = null;
            // this.toggleB6_3 = [];
            // this.toggleB6_4 = null;
            // this.disableExpress = false;

            for(let i = 0; i < 10; i++){
                this.$store.state.getFileAttachment[i] = [];
            }

            this.$store.state.additionalAtachments = [];
    },

    // NOTE - REQUEST CODE SSD25-1121783-2399(2025/11/25)
    floodResistantMessage(watertight){
      if(watertight === '耐水害 (床下)'){
        Swal.fire({
            html: '<div style="text-align: center;font-size:32px;font-weight:bold;">' +
                '耐水害 (床下)<br>' +
                '<span style="color: red;">2025/11/4以降の契約より可</span><br><br>',
            icon: 'warning',
            width : 500,
            allowOutsideClick: false,
            allowEscapeKey: false,
        });
        return;
      }
      
    },

    //NOTE - REQUEST CODE SSD25-0227783-2028(2025/03/28)
    async getSytemMaintenanceDatetime(){
        await axios({
            method: 'get',
            url: 'api/system_maintenance_datetime'
        }).then(({data}) => {
            this.isUnderMaintenance = data[0].is_undermaintenance;
            this.japanDate = data[0].japan_date;
            this.japanTime = data[0].japan_time;
            this.philippineTime = data[0].ph_time;
        })
    },

    // checkDate() {
    //   if (!this.softdeleteTriggered) {
    //     let currentDate = new Date();
    //     let isJanuary1_2024 = currentDate.getFullYear() === 2024 && currentDate.getMonth() === 0 && currentDate.getDate() === 1
    //     // let isJanuary1_2024 = currentDate.getFullYear() === 2023 && currentDate.getMonth() === 11 && currentDate.getDate() === 29

    //     if (isJanuary1_2024) {
    //       axios({
    //         method : 'post',
    //         url : 'api/updateHouseType'
    //       }).then((r) => {
    //         // console.log('HAPPY NEW YEAR!!!', r)
    //         this.softdeleteTriggered = true
    //       })
    //     }

    //   }
    // },


    // newPlannerPlans(){
    //   if (this.$store.state.loggedInUser.is_admin != 1) {
    //     axios({
    //     method: 'POST',
    //     url: 'api/new_get_in_charge',
    //     data: { 
    //       employeeCode : this.$store.state.loggedInUser.user_id
    //     }
    //   }).then(async ({data}) => {
    //     console.log(data,'plano ni planner bitch')
    //     this.$store.state.plannerControlNumber = data.map((r) => {
    //         if (r.ConstructionName) {
    //           if (r.ConstructionName.includes(" ")) {
    //             r.ConstructionName = r.ConstructionName.split(" ")[0] + " 様邸";
    //           } else if (r.ConstructionName.includes("　")) {
    //             r.ConstructionName = r.ConstructionName.split("　")[0] + " 様邸";
    //           } else {
    //             r.ConstructionName = r.ConstructionName + " 様邸";
    //           }
    //         }
    //         return r;
    //       });
    //       this.$store.state.plannerControlNumber.sort(
    //         (a, b) =>
    //           parseInt(a.ConstructionCode.split("-")[0]) -
    //           parseInt(b.ConstructionCode.split("-")[0])
    //       );
    //   })
    //   }
    // },

    closeDialogStore(){
      this.dialogStore = false
      this.$store.state.mainCloseStore = '1'
    },

    // PLANNER SEARCH COMBOBOX
    filteredPlanControlNumber(){
      this.handleInputKanji();
      if (this.tempData.customer_code && this.tempData.customer_code.length >= 2) {
        this.$set(this.tempData, "loading", false);
        const queryDigits = this.tempData.customer_code.slice(0, 2);
        // console.log(queryDigits,'queryDigitsxx')
        
        this.getPlan = this.$store.state.plannerControlNumber.filter(item => {
          // console.log(item.customer_code,'customer')
            const itemDigits = item.customer_code.slice(0, 2); // create plans only in CRS
            // const itemDigits = item.ConstructionCode.slice(0, 2); // for hrdsql database
            return queryDigits === itemDigits;
        });
        return this.getPlan;
      } else {
        this.$set(this.tempData, "loading", false);
        return this.$store.state.plannerControlNumber;
      }
    },
    
    formatCustomerCode() {
      
      if(this.tempData.customer_code){
        this.handleInputKanji();
        this.$set(this.tempData, "loading", true); // < Need nito para mag trigger muna yung formatCustomerCode
        let formattedCode = this.tempData.customer_code.toUpperCase();
        this.$store.state.getNumber = this.tempData.customer_code;
        if (formattedCode.length == 7) {
          formattedCode = formattedCode.substr(0, 7) + '-' + formattedCode.substr(7, 4); // Add hyphen after 7 digits
        }
        if(formattedCode.length == 12) {
          this.checkIfExisting(formattedCode);
          this.$store.state.getXml = formattedCode;
        }else{
          clearTimeout(this.authorityTimer)
          this.resetForm()
        }

        this.tempData.customer_code = formattedCode; // Update the model with formatted code
        this.$set(this.tempData, "loading", false); // < After mag input mawawala narin agad 
      }
    },

    handleKeyUp() {
      this.$refs.codeRef.updateSelf();
      
      // Initialize first
      if (!this.tempData.customer_code) {
        this.tempData.customer_code = ''
      }

      this.$set(this.tempData, 'loading', false)
      
      if (this.tempData.customer_code.length === 7) {
        this.tempData.customer_code = 
          this.tempData.customer_code.substr(0, 7) + '-' + this.tempData.customer_code.substr(7, 4) // Add hyphen after 7 digits
      }
      
      const queryDigits = this.tempData.customer_code
      
      this.getPlan = this.$store.state.plannerControlNumber.filter(item => {
        const itemDigits = item.customer_code
        // return queryDigits === itemDigits
        return itemDigits.includes(queryDigits)
      })
      
      return this.getPlan
    },

    handleChange() {
      if (!this.tempData.customer_code) {
        this.tempData.customer_code = ''
      }

      if(this.tempData.customer_code.length == 12) {
        this.checkIfExisting(this.tempData.customer_code)
        this.$refs.codeRef.isMenuActive = false
      }else{
        clearTimeout(this.authorityTimer)
        this.resetForm()
      }
    },

    imeStarted() {
      this.clearForm()
      this.isIMEActive = true;
      // console.log('IME started (Japanese input active)')
      alert('「半角英数字のみ入力可能です。入力モードを英語（半角）に切り替えてください。」')
    },

    imeEnded() {
      this.isIMEActive = false;
      // console.log('IME ended (Japanese input complete)')
      this.clearForm()
    },


    getPlanner(){
      this.$store.state.plannerControlNumber = []
      this.getPlan = []

      if(this.$store.state.loggedInUser.type != 'Admin') {
          axios({
          method: "POST",
          url: "api/getPlannerPlans",
          data: {
            loggedInUser: this.$store.state.loggedInUser,
          },
        }).then(({ data }) => {
          // this.$store.state.plannerControlNumber = data;
          // console.log(this.selectedItems,'selected')
          this.$store.state.plannerControlNumber = data.map((r) => {
            if (r.customer_name) {
              if (r.customer_name.includes(" ")) {
                r.customer_name = r.customer_name.split(" ")[0] + " 様邸";
              } else if (r.customer_name.includes("　")) {
                r.customer_name = r.customer_name.split("　")[0] + " 様邸";
              } else {
                r.customer_name = r.customer_name + " 様邸";
              }
            }
            return r;
          });
        });
      }
    },
    

    handleCustomerCode: function (code) {
      if (code) {
        this.tempData.customer_code = code;
      }
      // console.log(this.tempData.customer_code, code)
    },

    handleInput: function (distance) {
      if (distance) {
        this.tempData.distance_from_shore = distance;
      }
      // console.log(this.tempData.distance_from_shore, distance)
    },

    // NOTE - IF JAPANESE CHARACTER NUMBER IS INPUTTED AUTOMATIC REPLACE TO ENGLISH NUMBER
    handleInputKanji: function() {
      if (this.tempData.vertical_snow_cover) {
          this.tempData.vertical_snow_cover = this.convertJapaneseNumber(this.tempData.vertical_snow_cover.toString());
      }

      if(this.tempData.customer_code) {
          this.tempData.customer_code = this.convertJapaneseNumber(this.tempData.customer_code.toString());
      }

      if(this.tempData.reference_wind_velocity) {
        this.tempData.reference_wind_velocity = this.convertJapaneseNumber(this.tempData.reference_wind_velocity.toString());
      }
    },
    convertJapaneseNumber: function(text) {
        // console.log(text, 'text')
        if(text){
            text = text.replace(/\s+/g, ''); // Auto remove of spacing if meron
            text = text.replace(/[―‐ー－–—]/g, '-') // Convert kanji dashes
            const fullWidthNumbers = ['０', '１', '２', '３', '４', '５', '６', '７', '８', '９'];
            const arabicNumerals = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

            for (let i = 0; i < fullWidthNumbers.length; i++) {
                text = text.replace(new RegExp(fullWidthNumbers[i], 'g'), arabicNumerals[i]);
            }
            return text;
        }
    },
  
    arrangeHouseType() {
      // console.log(this.HOUSE_TYPES,'hahahahah')
      this.sortHouse = this.HOUSE_TYPES.map((res) => {
        if(res.id != 1) return res;
      });
      // if(this.sortHouse.length > 0){
      let b = "";
      // b = [0,11, 14, 4, 13, 3, 17, 1, 12, 2, 5, 8, 15, 7, 16, 9, 6, 10];
      // const rearrangedArray = b.map(index => ({ ...this.sortHouse[index] }));
      // this.sortHouse = rearrangedArray;
      b = this.sortHouse.splice(
        1,21, { ...this.sortHouse[18] }, { ...this.sortHouse[19] }, { ...this.sortHouse[20] }, { ...this.sortHouse[11] },
        { ...this.sortHouse[14] }, { ...this.sortHouse[4] }, { ...this.sortHouse[13] }, { ...this.sortHouse[3] }, { ...this.sortHouse[17] },
        { ...this.sortHouse[1] }, { ...this.sortHouse[12] }, { ...this.sortHouse[2] }, { ...this.sortHouse[5] }, { ...this.sortHouse[8] },
        { ...this.sortHouse[15] }, { ...this.sortHouse[7] }, { ...this.sortHouse[16] }, { ...this.sortHouse[9] }, { ...this.sortHouse[6] },
        { ...this.sortHouse[10] }
      );
      // console.log(b,'hatdogs')
      // console.log(this.sortHouse,'sortHouse')
      // }
      // {...this.sortHouse[17]},
    },

    getHouseGroup() {
      // console.log(this.tempData.house_type_id)
      let propertyExists = this.tempData.hasOwnProperty("house_type_id");
      if(propertyExists){
        this.filterGroup = [];
        this.kanaSetting = [];
        this.sortKanabakari = [];


        // DYNAMICALLY SHOW FIRE PROTECTION, HEAVY SNOW, KANABAKARI, WATERTIGHT, EARTHQUAKE RESISTANCE, HIGHFIREPROOF AND SEISMIC ISOLATION, 
        // IF THERE IS CHECK IN MASTER SETTINGS
        this.HOUSE_TYPE_GROUPS.filter((ger) => {
          ger.grouphouse.forEach((element) => {
            //NOTE - ADDED LINE BY UARY - FEB032026
           const incompatibleIds = [3, 4, 7];

            const hasIncompatibleId = ger.grouphouse.some(el => 
              incompatibleIds.includes(el.house_type_group_id)
            );

            if (element.house_type_id == this.tempData.house_type_id) {
              if (hasIncompatibleId) {
                this.tempData.double_earthquake_resistance = '0';
              }else{
                 this.tempData.double_earthquake_resistance = '1';
              }
              this.filterGroup.push(ger);
              this.showGroup = this.filterGroup[0];
              // console.log(this.filterGroup,'filterGroupsss')
            }
          });
        });

        // KANABAKARI(240,260,265) IN EVERY HOUSE TYPE ID 
        this.KANABAKARI_SETTINGS.filter((kana) => {
          // console.log(kana,'kanaaaa')
          kana.kanahousetype.forEach((elementx) => {
            // console.log(elementx,'elementx')
            if (elementx.house_type_id == this.tempData.house_type_id) {
              this.sortKanabakari.push(kana);
              // console.log(this.sortKanabakari,'sortKanabakari')
            }
          });
        });

        this.sortKanabakari.filter((vo) => {
          this.kanaSetting.push(vo.kanabakari_name);
          // console.log(vo.kanabakari_name, 'kanabakari_name')
        });
      }
      

      // HOUSE REMARKS IN EVERY HOUSE TYPE
      this.sortRemarks = [];
      if (this.tempData.house_type_id) {
        this.HOUSE_TYPE_REMARKS.filter((din) => {
          // console.log(din.id, this.tempData.house_type_id)
          if (din.id == this.tempData.house_type_id) {
            din.remarks.filter((r) => {
              this.sortRemarks.push(r);
            });
          }
        });

        // THIS WILL SHOW SAVE REMARKS IN CAD BASIC INFO REMARKS
        this.tempData.remarks = this.cadRequestBasicInformationRemarks.filter(
          (cadrem) => {
            return (
              cadrem.house_type_id === this.tempData.house_type_id &&
              cadrem.basic_information_id === this.tempData.id
            );
          }
        );

        // GET GC CONTROL NUMBER IN CAD BASIC INFO REMARKS
        this.getSiyo = this.tempData.remarks.filter((mvp) => {
          return mvp.gc_control_number;
        });
        this.tempData.gc_control_number =
          this.getSiyo[0] != null ? this.getSiyo[0].gc_control_number : null;

        // GET SNOW VALUE IN CAD BASIC INFO REMARKS
        this.getSnow = this.tempData.remarks.filter((isnow) => {
          return isnow.snow;
        });
        this.tempData.snow = this.getSnow[0] != null ? this.getSnow[0].snow : null;

        // this.tempData.gc_control_number = this.tempData.remarks.gc_control_number;
        // const filteredDataa = this.cadRequestBasicInformationRemarks.filter((gc) => {
        // 	return gc.house_type_id === this.tempData.house_type_id && gc.basic_information_id === this.tempData.id;
        // });
        // this.tempData.remarks = [];
        // console.log(this.sortRemarks,'this.sortRemarks', this.tempData.house_type_id)

        // this.HOUSE_TYPES.filter((res) => {
        //   if (res.id == this.tempData.house_type_id) {
        //     this.cadRequestBasicInformation.house_type_category = res.house_type_category_id;
        //   }
        // });
      }

      // JYUNTAIKA
      if (this.tempData.house_type_id === 3 || this.tempData.house_type_id === 29 
        || this.tempData.house_type_id === 22 || this.tempData.house_type_id === 23) {
          // console.log('test')
          
        this.getFireProtection = this.fireProtectionList.filter(item => item.value !== '3');
      } else {
        this.getFireProtection =  this.fireProtectionList;
      }

      // REMOVED DUE TO NEW RULE: NO MORE RESTRICTION 
      // this.checkInsuRestriction()
    },

    checkInsuRestriction() {
      // REMOVED DUE TO NEW RULE: NO MORE RESTRICTION 
      // if (this.isInsulationRestricted) {
      //   const grade = Number(this.tempData.grade_insulation)
        
      //   const message = [6, 7].includes(grade)
      //     ? '省エネ地域区分が6または7の場合、i-smileIIIW <br> i-smileIIIW+、HUGmefamWは選択できません。'
      //     : '多雪外かつ積雪量が100cm未満の場合、<br> i-smileIIIW、i-smileIIIW+、およびHUGmefamWも建築不可となります。';

      //   Swal.fire({
      //     html: `<div style="text-align: center;font-size:24px;">${message}</div>`,
      //     icon: 'warning',
      //     width: 630,
      //   })

      //   return false
      // }
      // return true

      console.log(this.tempData.grade_insulation)
    },

    // REMOVED DUE TO NEW RULE: NO MORE RESTRICTION 
    // isHouseTypeDisabled(item) {
    //   const restrictedIds = [37, 38, 39]
      
    //   const grade = Number(this.tempData.grade_insulation)
    //   const hasConditionMatch = [6, 7].includes(grade) || (grade === 5 && this.tempData.vertical_snow_cover < 100 && this.tempData.snow_classification === "一般地域")

    //   return hasConditionMatch && restrictedIds.includes(Number(item.id))
    // },

    clearForm() {
      this.$refs.Store.reset()
      this.tempData = {}
      this.showGroup = ""
      this.$store.commit('SET_EXISTING_REVISIONS', [])
      this.$store.state.cadRequestBasicInformation = {}
      this.$store.commit('setCadRequestBasicInformation', {})
      this.$store.state.authorityResponse = null
      this.toggleCadDisable = true
      this.cardLoader = false
      this.getPlanner()
      this.$store.state.customerCodeFromView = null
      this.$store.state.getXml = null
      this.$store.state.cadRequestLatestRevision = null
      this.ThermoAreaType = null
    },

    // OLD
    // checkIfExisting(value) {
    //   if (value) {
    //     if (typeof value === "string") {
    //       this.tempData.customer_code = value;
    //       this.overlay = false;
    //     } else if (typeof value === "object") {
    //       this.tempData.customer_code = value.ConstructionCode;
    //       // this.tempData.customer_code = value.customer_code;
    //       this.overlay = false;
    //     } else if (value == null) {
    //       // this.tempData.customer_code = null
    //       return;
    //     }
    //     // GET CUSTOMER AUTHORITY 
    //     try {
    //       this.$socket.emit('newUpdate', {
    //         dispatchType: this.env.request,
    //         data: {
    //           uniqId: this.loggedInUser.uniqId,
    //           customerCode : value,
    //           logIn_id : this.loggedInUser.user_id
    //         },
    //         functionType: 'get_authority'
    //       });
    //     } catch (error) {
    //       console.log(error, 'socket error')
    //     }
    //     // this.toggleCadRequestData();   // COMMENT AND MOVED TO SOCKETS DUE TO CUSTOMER AUTHORITY API
    //     // this.arrangeHouseType();       // COMMENT AND MOVED TO SOCKETS DUE TO CUSTOMER AUTHORITY API
    //     // this.getHouseGroup();
    //   } else {
    //     this.resetForm();
    //   }
    // },

    // NEW
    checkIfExisting(value) {
      this.toggleCadDisable = true;
      this.cardLoader = true;
      this.tempData.customer_name = null;
      this.tempData.expected_house_raising_date = null;
      this.tempData.sent_process_request_date = null;
      this.tempData.provisional_contract_date = null;
      this.tempData.provisional_contract_date_manual = null;
      this.tempData.contract_date = null;
      this.tempData.grade_insulation = null;
      this.ThermoAreaType = null;

      this.$store.commit("setCadRequestBasicInformation", {});

      clearTimeout(this.authorityTimer);

      let reachedAuthority = false;

      this.$socket.emit('newUpdate', {
        dispatchType: this.env.request,
        data: {
          uniqId: this.loggedInUser.uniqId,
          customerCode : value,
          logIn_id : this.loggedInUser.user_id
        },
        functionType: 'get_authority'
      });

      this.authorityTimer = setTimeout(() => {
        if (!reachedAuthority) {
          // alert("Unable to get plan information from HRD side. Please try to re-input your request");
          Swal.fire({
            icon: 'error',
            html: `<span style="font-size:22; font-weight:bold">Unable to get plan information from HRD side. <br>Please try to re-input your request.</span>`,
            width : 630,
          })
          this.clearForm()
        }
      }, 15000);
    },

    getCustomerCode(val) {
      this.tempData.customer_code = val;
      this.toggleCadRequestData();
    },
    // openDialog(){
    // 	// console.log(this.tempData.remarks)
    // },

    // getXmlCustomerCode(){
    //     axios({
    //         method: "POST",
    //         url: "api/get_xml_bundle",
    //         data: {
    //             customerCode: this.tempData.customer_code,
    //             loggedUser: this.loggedInUser,
    //         },
    //     }).then(({data}) => {
    //         if(data){
    //             this.XmlData = data.map((r) => {
    //                 r.created_at = moment(r.created_at).format('YYYY-MM-DD HH:mm:ss')
    //                 return r;
    //             })
    //         }
    //     })
    // },

    getCadExistingRevisions() {
      // MODIFIED BY UARY 042426
      // axios({
      //   method: "POST",
      //   url: "api/existing-revisions",
      //   data: {
      //     customerCode: this.tempData.customer_code,
      //     loggedUser: this.loggedInUser,
      //   },
      // }).then(({ data }) => {
      //   // this.$store.state.existingRevisions = data.filter((rec) => {
      //   // 	// rec.old_created = rec.created_at;
      //   // 	rec.time = new Date(rec.created_at).toLocaleTimeString("en-US", { hour12:false, hour: '2-digit', minute:'2-digit'});
      //   // 	rec.created_at =  new Date(rec.created_at).toLocaleDateString('en-US', { month:'2-digit', day:'2-digit'})
      //   // 	return rec
      //   // })
      //   this.$store.state.existingRevisions = data.filter((rec) => {
      //     // rec.old_created = rec.created_at;
      //     rec.whole_date = rec.created_at;
      //     rec.time = new Date(rec.created_at).toLocaleTimeString("en-US", {
      //       hour12: false,
      //       hour: "2-digit",
      //       minute: "2-digit",
      //     });
      //     rec.created_at = new Date(rec.created_at).toLocaleDateString("en-US", {
      //       month: "2-digit",
      //       day: "2-digit",
      //     });
      //     let rev1 = null;
      //     let rev2 = null;
      //     let explodeRevision = rec.revision_number.split("-");
      //     if (explodeRevision[0].length == 1) {
      //       rev1 = `0${explodeRevision[0]}`;
      //     } else {
      //       rev1 = explodeRevision[0];
      //     }

      //     if (explodeRevision[1].length == 1) {
      //       rev2 = `0${explodeRevision[1]}`;
      //     } else if (explodeRevision[1].length == 2) {
      //       if (/[a-zA-Z]/.test(explodeRevision[1])) {
      //         rev2 = `0${explodeRevision[1]}`;
      //       } else {
      //         rev2 = explodeRevision[1];
      //       }
      //     } else {
      //       rev2 = explodeRevision[1];
      //     }
      //     if (rec.attachments) {
      //       rec.attachments = rec.attachments.filter((res) => {
      //         if (
      //           res.filename.includes(rec.customer_code + "-" + rev1 + rev2) ||
      //           res.filename.includes(rec.revision_number)
      //         ) {
      //           return res;
      //         }
      //       });
      //     }
      //     return rec;
      //   });
      //   this.$store.state.actualButton = data.length > 0 ? true : false;
      //   // console.log(data, 'existingRevisions')
      // });

      axios({
        method: "POST",
        url: "api/existing-revisions",
        data: {
          customerCode: this.tempData.customer_code,
          loggedUser: this.loggedInUser,
        },
      }).then(({ data }) => {
        this.$store.state.existingRevisions = data.filter((rec) => {
          rec.whole_date = rec.created_at;
          rec.time = new Date(rec.created_at).toLocaleTimeString("en-US", {
            hour12: false,
            hour: "2-digit",
            minute: "2-digit",
          });
          rec.created_at = new Date(rec.created_at).toLocaleDateString("en-US", {
            month: "2-digit",
            day: "2-digit",
          });

          let rev1 = "";
          let rev2 = "";
          let explodeRevision = rec.revision_number.split("-");

          // --- Safety Check for 'TEST' or non-dashed revisions ---
          if (explodeRevision.length > 1) {
            rev1 = explodeRevision[0].length == 1 ? `0${explodeRevision[0]}` : explodeRevision[0];
            let part2 = explodeRevision[1];
            if (part2.length == 1) {
              rev2 = `0${part2}`;
            } else if (part2.length == 2 && /[a-zA-Z]/.test(part2)) {
              rev2 = `0${part2}`;
            } else {
              rev2 = part2;
            }
          } else {
            rev1 = rec.revision_number;
            rev2 = "";
          }

          if (rec.attachments) {
            // --- Added the envDB check here ---
            if (this.envDB == 'hrd_cad_request') {
              rec.attachments = rec.attachments.filter((res) => {
                if (
                  res.filename.includes(rec.customer_code + "-" + rev1 + rev2) ||
                  res.filename.includes(rec.revision_number)
                ) {
                  return res;
                }
              });
            } else {
              // Standard check for other databases
              rec.attachments = rec.attachments.filter((res) => {
                if (res.filename.includes(rec.revision_number)) {
                  return res;
                }
              });
            }
          }
          return rec;
        });

        this.$store.state.actualButton = data.length > 0 ? true : false;
      });


      axios({
        method: "POST",
        url: "api/existing-draft-revisions",
        data: {
          customerCode: this.$store.state.cadRequestBasicInformation.construction_code,
          loggedUser: this.loggedInUser,
        },
      }).then(({ data }) => {
        this.$store.state.draftButton = data.length > 0 ? true : false;
        // console.log(this.draftButton, "draft")
      });
  // test
      axios({
        method: "POST",
        url: "api/existing-deleted-revisions",
        data: {
          customerCode: this.$store.state.cadRequestBasicInformation.construction_code,
          loggedUser: this.loggedInUser,
        },
      }).then(({ data }) => {
        this.$store.state.deleteButton = data.length > 0 ? true : false;
      });

    },

    generatePiraPDF() {
      const data = {
        basicInformation: this.tempData,
        latestRevision: this.$store.state.cadRequestLatestRevision,
        revisionContent: this.$store.state.cadRequestRevisionContent,
      };
      // console.log(data, "data")
      window.open(`pira-data/${this.tempData.construction_code}`, "_blank").focus();
    },

    generatePDF() {
      // return console.log(this.$store.state.cadRequestLatestRevision)
      const cadRequestData = {
        basicInformation: this.tempData,
        latestRevision: this.$store.state.cadRequestLatestRevision,
        revisionContent: this.$store.state.cadRequestRevisionContent,
      };

      // console.log(cadRequestData)
      // axios({
      // 	method:'POST',
      // 	url: 'api/cad-form',
      // 	data: cadRequestData
      // }).then(({ data }) => {
      // 	console.log(data, "data itu")
      window.open(`cad-form/${this.tempData.construction_code}`, "_blank").focus();
      // })
    },

    resetForm() {
      if (this.$refs.Store) this.$refs.Store.resetValidation()
      this.toggleCadDisable = true
      this.tempData.house_type_id = null;
      if (this.tempData.remarks) this.tempData.remarks.splice(0);
      this.tempData.fire_protection = null;
      this.tempData.heavy_snow = null;
      this.tempData.rectangle_meter = null;
      this.tempData.water_tight = null;
      this.tempData.double_earthquake_resistance = null;
      this.tempData.high_fireproof_outer_wall = null;
      this.tempData.seismic_isolation = null;
      this.tempData.grade_insulation = null;
      this.ThermoAreaType = null;
      this.tempData.expected_house_raising_date = null
      this.tempData.sent_process_request_date = null
      this.tempData.provisional_contract_date = null
      this.tempData.provisional_contract_date_manual = null
      this.tempData.contract_date = null
      this.tempData.site_address_prefecture_code = null
      this.tempData.site_address_prefecture_code = null
      this.tempData.power_company_name = null
      this.tempData.vertical_snow_cover = null
      this.tempData.reference_wind_velocity = null
      this.tempData.distance_from_shore = null
      this.tempData.snow_classification = null
      this.tempData.kakouirai_reason = null
      this.tempData.customer_name = null
      this.showGroup = ""
      this.$store.commit('SET_EXISTING_REVISIONS', [])
      this.$store.state.cadRequestBasicInformation = {}
      this.$store.commit('setCadRequestBasicInformation', {})
      this.$store.state.authorityResponse = null
      this.$store.state.customerCodeFromView = null
      this.$store.state.getXml = null
      this.$store.state.cadRequestLatestRevision = null
    },

    getSelectedHouseType() {
      if (!this.tempData.house_type_id) return;

      const data = this.HOUSE_TYPES.find((res) => res.id == this.tempData.house_type_id);
      // console.log(data,'data')
      if (data) return data.name;
    },

    GET_DATA_FROM_HRD() {
      if (!this.tempData.customer_code) return;
      this.$socket.emit("newUpdate", {
        dispatchType: this.env.request,
        data: {
          customerCode: this.tempData.customer_code,
          uniqId: this.loggedInUser.uniqId,
        },
        functionType: "updateData",
      });
    },

    CHECK_FOR_DATE() {
      if (!this.tempData.customer_code) return;
      this.$socket.emit("newUpdate", {
        dispatchType: this.env.request,
        data: {
          customerCode: this.tempData.customer_code,
          uniqId: this.loggedInUser.uniqId,
        },
        functionType: "updateProcessDate",
      });
    },


    transferToTempData(HRD_DATA) {
      this.tempData.distance_from_shore = null;
      // console.log(HRD_DATA, "HRDDATA");
      // console.log(this.cadRequestBasicInformation.sent_process_request_date,'cadReq')
      if (typeof HRD_DATA != "undefined") {
        //NOTE: DATES
        let ExpectedHouseRaisingDate = HRD_DATA.ExpectedHouseRaisingDate;
        HRD_DATA.expected_house_raising_date = !ExpectedHouseRaisingDate ? null : ExpectedHouseRaisingDate.slice(0, 10);

        let SentProcessRequestDate = HRD_DATA.SentProcessRequestDate; HRD_DATA.sent_process_request_date = !SentProcessRequestDate ? null : SentProcessRequestDate.slice(0, 10);
        // console.log(HRD_DATA.sent_process_request_date, 'SentProcessRequestDate')
        let ConstructionStatus = HRD_DATA.ConstructionStatus;
        HRD_DATA.ConstructionStatus = !ConstructionStatus ? null : ConstructionStatus;

        let ProvisionalContractDate = HRD_DATA.ProvisionalContractDate;
        HRD_DATA.provisional_contract_date = !ProvisionalContractDate ? null : ProvisionalContractDate.slice(0, 10);

        let ContractDate = HRD_DATA.ContractDate;
        HRD_DATA.contract_date = !ContractDate ? null : ContractDate.slice(0, 10);

        //NOTE: PREFECTURE CODE
        HRD_DATA.SiteAddressPrefectureCode = Number(HRD_DATA.SiteAddressPrefectureCode);
        HRD_DATA.site_address_prefecture_code =
            HRD_DATA.SiteAddressPrefectureCode < 10
              ? `0${HRD_DATA.SiteAddressPrefectureCode}`
              : String(HRD_DATA.SiteAddressPrefectureCode);
        let isSite = this.PREFECTURES.some(
          (r) => r.prefecture_code === HRD_DATA.site_address_prefecture_code
        );
        if(!isSite){
          HRD_DATA.site_address_prefecture_code = null;
        }
        //NOTE: CAD REQUEST SIDE HOUSE TYPE DATA
        if (HRD_DATA.ConstructionTypeCode) {
          // HRD_DATA.house_type_id = HRD_DATA.ConstructionTypeCode != '0'
          // 						?  this.HOUSE_TYPES.find(({name}) => name == HRD_DATA.ConstructionTypeName).id
          // 						: null
          if (HRD_DATA.ConstructionTypeCode != "0") {
            if (HRD_DATA.ConstructionTypeName.includes("GRAND SMART")) {
              HRD_DATA.house_type_id = this.HOUSE_TYPES.find(
                ({ name }) => name == "GRAND SMART"
              ).id;
            }else {
              if(HRD_DATA.ConstructionTypeName == "i-smile＋"){
                HRD_DATA.ConstructionTypeName = "i-smile+"
              }
              HRD_DATA.house_type_id = this.HOUSE_TYPES.find(
                ({ name }) => name == HRD_DATA.ConstructionTypeName
              );
            }
          }

          // HRD_DATA.remarks = this.HOUSE_TYPES.find(({name}) => name == HRD_DATA.ConstructionTypeName).remarks.map(res => res.remark_id)
        } else if (HRD_DATA.ConstructionTypeCode == null) {
          this.HOUSE_TYPES.filter((res) => {
            if (HRD_DATA.SettingCharacter) {
              if (HRD_DATA.SettingCharacter == res.name) {
                HRD_DATA.house_type_id = res.id;
              } else {
                if (HRD_DATA.SettingCharacter == "i-smile＋") {
                  if (res.name == "i-smile") {
                    // continue;
                    console.log(res);
                  } else if (HRD_DATA.SettingCharacter.includes(res.name)) {
                    HRD_DATA.house_type_id = res.id;
                  }
                } else if (HRD_DATA.SettingCharacter.includes(res.name)) {
                  HRD_DATA.house_type_id = res.id;
                }
              }
            }
          });
        }
        // console.log(HRD_DATA, "hrddata")

        //NOTE: WIND VELOCITY
        HRD_DATA.reference_wind_velocity = HRD_DATA.ReferenceWindVelocity;
        HRD_DATA.reference_wind_velocity2 = HRD_DATA.ReferenceWindVelocity2;

        //NOTE: SNOW DEPTH
        HRD_DATA.vertical_snow_cover = HRD_DATA.SnowAccumulation;

        //NOTE : TASETSU
        let TasetsuArea = HRD_DATA.HeavySnowArea;
        HRD_DATA.snow_classification = TasetsuArea == 0 ? null : TasetsuArea == 1 ? '多雪区域内' : TasetsuArea == 2 ? '一般地域' : null;
        
        //NOTE: POWER COMAPNY NAME
        HRD_DATA.power_company_name = HRD_DATA.ElectricCompanyName;

      }

      // this.tempData.house_type_id = null;
      this.tempData = { ...this.tempData, ...HRD_DATA };
      this.tempData.basic_specification = HRD_DATA.BasicSpecificationName; //temp
      this.tempData.ConstructionStatus = HRD_DATA.ConstructionStatus; //temp
      this.tempData.grade_insulation = HRD_DATA.ThermoAreaType
      this.ThermoAreaType = HRD_DATA.ThermoAreaType
      // this.tempData.kakouirai_reason = HRD_DATA.ConstructionStatus == "1" ? 5 : null; // NOTE : REFORM
      // this.tempData.sent_process_request_date = HRD_DATA.SentProcessRequestDate;
      // this.tempData.construction_code = HRD_DATA.BasicSpecificationName  //temp
      // console.log(this.tempData, "this.tempData", HRD_DATA);

      // if(this.tempData.remarks && data.remarks){
      // 	this.tempData.remarks = data.remarks.map(res => {
      // 		return res.remark_id
      // 	});
      // }
      this.$refs.Store.resetValidation(); //temp

      // console.log('this.tempData', this.tempData)
      // console.log('HRD_DATA', HRD_DATA)
    },

    Store() {

      this.$store.state.getNumber = 1; // Para to sa condition sa mounted ng HP
      this.$store.state.mainCloseStore = null; // para sa close button condition
      // HUGme trapping
      if (
        this.tempData.snow_classification == "多雪区域内" &&
        this.tempData.house_type_id == "3"
      ) {
        this.snackbar = {
          text:
            "垂直積雪量100cm以上または多雪区域内の場合 HUGme famを選択する必要があります。建物タイプもしくは敷地情報を修正の上、再度保存お願い致します。",
          color: "red",
          icon: "mdi-alert-circle",
          mode: "multi-line",
          title: "Error",
          show: true,
        };
        return false;
      }

      if (this.tempData.customer_code.length < 12) {
        Swal.fire({
            icon: 'error',
            title: `Error.`,
            html: `<span style="font-size:21px;font-weight:bold;">お客様コードの桁数が足りません。再度入力してください。</span>`,
            width : 630,
        });
        return false;
      } 
      // else if (!/^\d+-\d+$/.test(this.tempData.customer_code)) {
      //     Swal.fire({
      //       icon: 'error',
      //       title: `Error.`,
      //       text: 'お客様コードは数字とハイフンの形式で必要です',
      //     });
      //     return false;
      // }

      if(!this.tempData.house_type_id){
        this.requiredSnackbar = {
          message: "Please select house type.",
          color: "red",
          icon: "mdi-alert-circle",
          show: true,
        };
        return
      }

      if (
        this.tempData.vertical_snow_cover >= 100 &&
        this.tempData.house_type_id == "3"
      ) {
        this.snackbar = {
          text:
            "垂直積雪量100cm以上または多雪区域内の場合 HUGme famを選択する必要があります。建物タイプもしくは敷地情報を修正の上、再度保存お願い致します。",
          color: "red",
          icon: "mdi-alert-circle",
          mode: "multi-line",
          title: "Error",
          show: true,
        };
        return false;
      }

      // fields without data
      let trapHouseGroup = this.showGroup["grouphouse"].filter((v) => {
        // console.log(v.house_type_id,'vvvvvvvvvv')
        return v;
      });
      // console.log(trapHouseGroup,'trapHouseGroup')
      // console.log(this.tempData)
      // return false;
      // this.tempData.gc_control_number =
      if (this.tempData.kakouirai_reason == 1) {
        this.$store.state.kakou_reason = this.tempData.kakouirai_reason;
        // console.log(this.$store.state.kakou_reason,'One')
      } else if (this.tempData.kakouirai_reason == 2) {
        this.$store.state.kakou_reason = this.tempData.kakouirai_reason;
        // console.log(this.$store.state.kakou_reason,'Two')
      }

      // GRADE INSULATION RESTRICTION
      if(!this.tempData.grade_insulation){
        this.requiredSnackbar = {
          message: "Please select 省エネ地域区分.",
          color: "red",
          icon: "mdi-alert-circle",
          show: true,
        };
        return false
      }

      // REMOVED DUE TO NEW RULE: NO MORE RESTRICTION 
      // if (this.checkInsuRestriction() === false) {
      //   return false
      // }

      if ((this.cadRequestBasicInformation.sent_process_request_date != null || this.tempData.sent_process_request_date != null) && this.tempData.kakouirai_reason == null) {
        alert("Plan is with Kakouirai Date. Need to fill out Kakouirai Reason");
        return false;
      }
      // Validation for Required fields if without data
      else if ((this.tempData.house_type_id === trapHouseGroup.house_type_id && this.showGroup.fire_protection === 1 && this.showGroup.kanabakari === 1) ||
        // Inner condition for validation
        ((this.showGroup.earth_quake_resistance === null || this.showGroup.high_fire_proof_outer_wall === null) && (this.tempData.fire_protection === null || this.tempData.rectangle_meter === null ||
            this.tempData.rectangle_meter === ""))) {
        this.requiredSnackbar = {
          message: "Please fill out required fields",
          color: "red",
          icon: "mdi-alert-circle",
          show: true,
        };
        return false;
      } else if ((this.tempData.house_type_id === trapHouseGroup.house_type_id && this.showGroup.fire_protection === 1 && this.showGroup.kanabakari === 1) ||
        // Inner condition for validation
        (this.showGroup.earth_quake_resistance === 1 && this.showGroup.high_fire_proof_outer_wall === 1) || this.tempData.fire_protection === null ||
        this.tempData.rectangle_meter === null || (this.showGroup.high_fire_proof_outer_wall !== null && this.tempData.high_fireproof_outer_wall === null) ||
        (this.showGroup.earth_quake_resistance !== null && this.tempData.double_earthquake_resistance === null) || (this.showGroup.seismic_isolation !== null &&
          this.tempData.seismic_isolation === null)) {
        this.requiredSnackbar = {
          message: "Please fill out all required fields",
          color: "red",
          icon: "mdi-alert-circle",
          show: true,
        };
        return false;
      } else {
        if (this.$refs.Store.validate()) {
          const myForm = document.getElementById("Store");
          const formdata = new FormData(myForm);
          this.getHouseCategory(this.tempData.house_type_id); // Dito para magkaroon ng house_type_category new or existing data man yan, eeeyyy
          this.setCadRequestBasicInformation(this.tempData)
            .then(() => {
              // para to sa close button
              // console.log(this.tempData, 'ere ang data na magsesave sa cadbasicinfo')
              this.$store.state.getBossiCad = this.tempData
              this.dialogStore = false;
              this.$store.state.denkiHousetype = this.tempData.house_type_id;
              if(!this.$store.state.editMode){
                this.getCadExistingRevisions();
              }else{
                this.$store.state.editCadRequestRevisionContent.house_type_id = this.$store.state.cadRequestBasicInformation.house_type_id
                // this.$store.state.editCadRequestRevisionContent.house_type_name = this.$store.state.HOUSE_TYPES.map((r) => r.id == this.$store.state.cadRequestBasicInformation.house_type_id)
                this.HOUSE_TYPES.forEach(element => {
                  if(element.id == this.$store.state.cadRequestBasicInformation.house_type_id){
                    this.$store.state.editCadRequestRevisionContent.house_type_name = element.name;
                    return;
                  }
                });

              }
            })
            .catch((error) => {
              console.log(error, "error");
            });
        }
      }

      // else if (this.tempData.house_type_id == trapHouseGroup.house_type_id && this.tempData.customer_code == null || this.tempData.house_type_id == null ||
      // 	this.tempData.site_address_prefecture_code == null|| this.tempData.power_company_name == null ||
      // 	this.tempData.vertical_snow_cover == null || this.tempData.reference_wind_velocity == null ||
      // 	this.tempData.distance_from_shore == null || this.tempData.fire_protection == null || this.tempData.rectangle_meter == null)
      // {
      // 	this.snackbar = {
      // 		message : 'Please fill out all required fields',
      // 		color : 'red',
      // 		icon: 'mdi-alert-circle',
      // 		show: true
      // 	}
      // 	return false
      // }

      // else if (this.tempData.house_type_id == trapHouseGroup.house_type_id && this.tempData.customer_code == null || this.tempData.house_type_id == null ||
      // 	this.tempData.site_address_prefecture_code == null|| this.tempData.power_company_name == null ||
      // 	this.tempData.vertical_snow_cover == null || this.tempData.reference_wind_velocity == null ||
      // 	this.tempData.distance_from_shore == null || this.tempData.fire_protection == null ||
      // 	this.tempData.snow_classification == null || this.tempData.rectangle_meter == null)
      // {
      // 	this.snackbar = {
      // 		message : 'Please fill out all required fields',
      // 		color : 'red',
      // 		icon: 'mdi-alert-circle',
      // 		show: true
      // 	}
      // 	return false
      // }

      // else if(this.tempData.house_type_id == trapHouseGroup.house_type_id && this.tempData.customer_code == null || this.tempData.house_type_id == null ||
      // 	this.tempData.site_address_prefecture_code == null|| this.tempData.power_company_name == null ||
      // 	this.tempData.vertical_snow_cover == null || this.tempData.reference_wind_velocity == null ||
      // 	this.tempData.distance_from_shore == null || this.tempData.fire_protection == null || this.tempData.snow_classification == null ||
      // 	this.tempData.rectangle_meter == null || this.tempData.high_fireproof_outer_wall == null || this.tempData.double_earthquake_resistance == null)
      // {
      // 	this.snackbar = {
      // 		message : 'Please fill out all required fields',
      // 		color : 'red',
      // 		icon: 'mdi-alert-circle',
      // 		show: true
      // 	}
      // 	return false
      // }

      // else if(
      // 	this.tempData.customer_code == null ||
      // 	this.tempData.house_type_id == null ||
      // 	this.tempData.site_address_prefecture_code == null||
      // 	this.tempData.power_company_name == null ||
      // 	this.tempData.vertical_snow_cover == null ||
      // 	this.tempData.reference_wind_velocity == null ||
      // 	this.tempData.distance_from_shore == null ||
      // 	this.tempData.snow_classification == null ||
      // 	this.tempData.fire_protection == null ||
      // 	this.tempData.rectangle_meter == null ||
      // 	this.tempData.double_earthquake_resistance == null ||
      // 	this.tempData.high_fireproof_outer_wall == null
      // ){
      // this.snackbar = {
      // 		message : 'Please fill out all required fields',
      // 		color : 'red',
      // 		icon: 'mdi-alert-circle',
      // 		show: true
      // 	}
      // 	// alert('Please fill out all required fields')
      // 	return false
      // }
    },

    getPrefectureCode(prefecture) {
      // console.log(prefecture)
      this.tempData.site_address_prefecture_code = prefecture;
    },

    // OLD
    // async toggleCadRequestData() {
    //   // console.log(this.tempData, "temp")
    //   this.toggleCadDisable = true
    //   this.cardLoader = true
    //   this.resetForm();

    //   if (!this.tempData.customer_code) return;
    //   // this.tempData.gc_control_number = null;
    //   else this.getHouseCategory(this.tempData.house_type_id);
    //   const timeOut = 1000;
    //   clearTimeout(this.timeout);
    //   this.timeout = setTimeout(() => {
    //     // yung nasa loob, gagana lang after 1.5 secs, ka input. nag rereset

    //     this.$store.state.cadRequestLatestRevision = null; //> pang clear sa cad request detail page

    //     // this.resetForm();
    //     // this.tempData.loading = true
    //     this.$set(this.tempData, "loading", true); // >  same lang sya ng nasa taas na naka comment, pero mas maangas sya.
    //     this.$nextTick(() => {
    //       this.getCadRequestBasicInformation(this.tempData) // > action to, yung state na nilalagyan nya eto 'cadRequestBasicInformation'
          
    //         .then(async () => {
    //           // console.log(this.cadRequestBasicInformation, 'this.cadRequestBasicInformation')
    //           if (this.cadRequestBasicInformation == 0) {
    //             // Pag walang nakuhang data sa CAD REQUEST databse
    //             this.GET_DATA_FROM_HRD();
    //           } else {
    //             this.CHECK_FOR_DATE(); // > Kahit may previous data yung contract, provisional, expected at sent process dates, kukuhanin nya palagi yung latest dates dito.
    //             this.$set(this.tempData, "loading", false); // > this.tempDate.loading = false; unahin mo lagi to, nag e-errro pag huli. kasi reactive yung object.
    //             this.tempData = { ...this.tempData, ...this.cadRequestBasicInformation };
    //             this.tempData.house_type_id = +this.cadRequestBasicInformation.house_type_id;
    //             // this.getHouseCategory(this.tempData.house_type_id);
    //             this.tempData.gc_control_number = this.getSiyo[0] != null ? this.getSiyo[0].gc_control_number : null;
    //             this.tempData.snow = this.getSnow[0] != null ? this.getSnow[0].snow : null;
    //             // if(this.cadRequestBasicInformationRemarks.length > 0){
    //             // 		let gc_control_number = this.cadRequestBasicInformation.remarks.map((r) => {
    //             // 			if (r.remark_id == 18) return r;
    //             // 			else return null;
    //             // 		});
    //             // 	this.tempData.gc_control_number = gc_control_number[0] != null ? gc_control_number[0].gc_control_number : null;
    //             // 	}

    //             if (this.cadRequestBasicInformation) {
    //               if (this.tempData.seismic_isolation == null) {
    //                 this.tempData.seismic_isolation = "0";
    //               } else {
    //                 this.tempData.seismic_isolation = this.cadRequestBasicInformation.seismic_isolation;
    //               }

    //               // this.tempData.remarks = this.cadRequestBasicInformation.remarks.map(res => res.remark_id)
    //             }

    //             // this.tempData.remarks = this.cadRequestBasicInformation.remarks.map(res => res.remark_id)
    //             // console.log(this.tempData.remarks,'tempData.remarks')
    //             // this.tempData.remarks = this.sortRemarks.map(res => res.remark_id)
    //             // this.tempData.expected_house_raising_date = this.tempData.expected_house_raising_date != null ? this.tempData.expected_house_raising_date.slice(0, 10) : null;
    //             // this.tempData.sent_process_request_date = this.tempData.sent_process_request_date != null ? this.tempData.sent_process_request_date.slice(0, 10) : null;
    //             // this.tempData.provisional_contract_date = this.tempData.provisional_contract_date != null ? this.tempData.provisional_contract_date.slice(0, 10) : null;
    //             // this.tempData.contract_date = this.tempData.contract_date != null ? this.tempData.contract_date.slice(0, 10) : null;
    //             await this.checkPrefecture(this.tempData.site_address_prefecture_code);

    //             this.tempData.rectangle_meter = this.tempData.rectangle_meter ? this.kanaSetting.includes(this.tempData.rectangle_meter) ? this.tempData.rectangle_meter : null : null;
    //             // console.log(this.tempData, "tempdata")
    //             // this.tempData.gc_control_number = this.cadRequestBasicInformation.remarks.length > 0 ? this.cadRequestBasicInformation.remarks.filter(r => r.gc_control_number !== null)[0].gc_control_number : null
    //             // this.tempData.gc_control_number = control_number != null ? control_number : null;
                
    //             this.$store.state.cadRequestBasicInformation = this.tempData;
    //           }
    //         });
    //     });
    //     this.disabled = false;
    //   }, timeOut);
    // },

    // NEW 2026-04-11
    toggleCadRequestData() {
      this.toggleCadDisable = true;
      this.cardLoader = true;
      this.resetForm();

      if (!this.tempData.customer_code) return Promise.resolve();

      this.getHouseCategory(this.tempData.house_type_id);

      const timeOut = 1000;
      clearTimeout(this.timeout);

      return new Promise((resolve) => {
        this.timeout = setTimeout(() => {
          this.$store.state.cadRequestLatestRevision = null;
          this.$set(this.tempData, "loading", true);

          this.$nextTick(() => {
            this.getCadRequestBasicInformation(this.tempData)
              .then(async () => {
                
                if (this.cadRequestBasicInformation == 0) {
                  await this.GET_DATA_FROM_HRD(); 
                } else {
                  this.CHECK_FOR_DATE();
                  this.$set(this.tempData, "loading", false);
                  
                  this.tempData = { ...this.tempData, ...this.cadRequestBasicInformation };
                  this.tempData.house_type_id = +this.cadRequestBasicInformation.house_type_id;

                  this.tempData.gc_control_number = this.getSiyo[0] != null ? this.getSiyo[0].gc_control_number : null;
                  this.tempData.snow = this.getSnow[0] != null ? this.getSnow[0].snow : null;

                  if (this.cadRequestBasicInformation) {
                    if (this.tempData.seismic_isolation == null) {
                      this.tempData.seismic_isolation = "0";
                    } else {
                      this.tempData.seismic_isolation = this.cadRequestBasicInformation.seismic_isolation;
                    }
                  }

                  this.tempData.expected_house_raising_date = this.tempData.expected_house_raising_date != null ? this.tempData.expected_house_raising_date.slice(0, 10) : null;
                  this.tempData.sent_process_request_date = this.tempData.sent_process_request_date != null ? this.tempData.sent_process_request_date.slice(0, 10) : null;
                  this.tempData.provisional_contract_date = this.tempData.provisional_contract_date != null ? this.tempData.provisional_contract_date.slice(0, 10) : null;
                  this.tempData.contract_date = this.tempData.contract_date != null ? this.tempData.contract_date.slice(0, 10) : null;
                  this.tempData.grade_insulation = this.tempData.grade_insulation ? this.tempData.grade_insulation : null;

                  await this.checkPrefecture(this.tempData.site_address_prefecture_code);

                  this.tempData.rectangle_meter = this.tempData.rectangle_meter ? (this.kanaSetting.includes(this.tempData.rectangle_meter) ? this.tempData.rectangle_meter : null) : null;
                  
                  this.$store.state.cadRequestBasicInformation = this.tempData;
                }

                this.disabled = false;

                resolve(); 
                
              }).catch((err) => {
                console.error(err);
                this.disabled = false;
                resolve();
              });
          });
        }, timeOut);
      });
    },

    getHouseCategory(id) {
      if (id) {
        this.HOUSE_TYPES.filter((res) => {
          if (res.id == id) {
            this.tempData.house_type_category = res.house_type_category_id;
            return;
          }
        });
      }
    },
    checkPrefecture(code) {
      // if(this.PREFECTURES.length == 0) {

      // this.$store.dispatch('_getPrefectures');

      // console.log(this.PREFECTURES,'PREFECTURES')
      let pref = this.PREFECTURES.filter((r) => {
        // console.log(r.prefecture_code,'r')
        if (r.prefecture_code == code) {
          return r;
        } else {
        }
      });

      if (pref.length == 0) {
        // this.tempData.site_address_prefecture_code = code + "A"
        this.tempData.site_address_prefecture_code = null;
      }
      // console.log(pref,'pref')
      // }
    },

    toggleDialogStore(val) {
      this.dialogStore = val;
      this.getHouseGroup();
    },

    toggleUpdateDialog(item) {
      if (item) {
        this.tempData = { ...item };
        this.dialogUpdate = true;
      } else {
        this.dialogUpdate = false;
      }
    },

    // OLD
    // async linkedData() {
    //   this.tempData.customer_code = this.$store.state.customerCodeFromView;
    //   if (this.tempData.customer_code) {
    //     await this.toggleCadRequestData().then(() => {
    //       setTimeout(async () => {
    //         // await this.Store(); 
    //         if (
    //           this.loggedInUser.is_admin == 1 ||
    //           this.loggedInUser.is_hrd_requestor == 1
    //         ) {
    //           this.dialogStore = false;
    //         } else {
    //           this.dialogStore = true;
    //         }

    //         // this.dialogStore = false
    //       }, 1000);
    //     });
    //   }
    // },

    //NEW 2026-04-11
    async linkedData() {
      this.tempData.customer_code = this.$store.state.customerCodeFromView;
      if (this.tempData.customer_code) {
        await this.toggleCadRequestData();
        if ( (this.loggedInUser.is_admin == 1 || this.loggedInUser.is_hrd_requestor == 1) && this.$refs.Store.validate() ) {
          this.dialogStore = false;
        } else {
          this.dialogStore = true;
        }
      }
    },
    
    // getInChargePlanner() {
    //   if (this.$store.state.loggedInUser.is_admin != 1) {
    //     this.$socket.emit("newUpdate", {
    //       dispatchType: this.env.request,
    //       data: {
    //         plannerCode: this.loggedInUser.user_id,
    //         uniqId: this.loggedInUser.uniqId,
    //       },
    //       functionType: "planInCharge",
    //     });
    //   }
    // },

    // handleContextMenu(event) {
    //     // Prevent the default context menu behavior
    //     event.preventDefault();
    // },
    // handleKeyDown(event) {
    //   // Disable F12 and Ctrl+Shift+I (Windows/Linux) or Cmd+Option+I (Mac)
    //   if ((event.key === 'F12') || ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'I')) {
    //       event.preventDefault();
    //   }
    //   // Disable right-click
    //   if (event.button === 2) {
    //       event.preventDefault();
    //   }
    // }
  },


  mounted() {
    // window.addEventListener('keydown', this.handleKeyDown);
    // this.newPlannerPlans();
    // this.getInChargePlanner();
    // this.cadRequestVer().then(() => {
    //   this.getUpdatedVersion();
    // });

    //NOTE - REQUEST CODE SSD25-0227783-2028(2025/03/28)
    this.getSytemMaintenanceDatetime();
    
    this._getPrefectures();
    this.getPlanner();
    this._getRemarks();
    this._getHouseTypes();
    this._getHouseTypeGroups();
    this._getKanabakari();
    this._getHouseTypeRemarks();
    this._getCadBasicInforRemarks();
    this._getElectricCompanyName();
    // this._getPrefectures().then(() => {
    //   this._getRemarks().then(() => {
    //     this._getHouseTypes().then(() => {
    //       this._getHouseTypeGroups().then(() => {
    //         this._getKanabakari().then(() => {
    //           this._getHouseTypeRemarks().then(() => {
    //             this._getCadBasicInforRemarks().then(() => {
    //                 this._getElectricCompanyName();
    //             });
    //           });
    //         });
    //       });
    //     });
    //   });
    // });
    this.arrangeHouseType();
    // this.getHouseGroup();

    if (Object.keys(this.tempData).length == 0) {
      this.dialogStore = true;
      
    }
    this.linkedData();
    // this.checkDate()
  },

  // DISABLED F12 AND RIGHT CLICK
  beforeDestroy() {
      // Remove the keydown event listener when the component is destroyed
      // window.removeEventListener('keydown', this.handleKeyDown);
  },

  watch: {
    "$store.state.mainDialog"(val){
      if(val){
        this.dialogStore = true;
      }
    },

    "$store.state.PREFECTURES"(val) {
      if (val.length > 0) {
        this.disabledcustomercode = false;
        this.overlay = false;
      } else {
        this.disabledcustomercode = true;
      }
    },

    // OLD 042226
    // tempData(val) {
    //   // console.log(val.house_type_id['id'],'house_type_idsss') //<--- if the control number is without data in local database
    //   // console.log(val.house_type_id,'house_type_idsss')
    //   if(val.house_type_id){
    //     if(val.house_type_id == 1 || val.house_type_id == 4 || val.house_type_id == 5 || val.house_type_id == 6 || val.house_type_id == 9 || val.house_type_id == 11){
    //       val.house_type_id = null;
    //     }
    //   }
    //   // tempData.house_type_id
    //   // console.log(val.house_type_id)
    //   // this.$store.state.kakou_reason = val.kakouirai_reason;
    //   let propertyExists = val.hasOwnProperty("house_type_id");
    //   this.filterGroup = [];
    //   if (propertyExists) {
    //     this.sortKanabakari = [];

    //     // DYNAMICALLY SHOW FIRE PROTECTION, HEAVY SNOW, KANABAKARI, WATERTIGHT, EARTHQUAKE RESISTANCE, HIGHFIREPROOF AND SEISMIC ISOLATION, 
    //     // IF THERE IS CHECK IN MASTER SETTINGS
    //     if(this.cadRequestBasicInformation != 0){
    //       this.HOUSE_TYPE_GROUPS.filter((ger) => {
    //         ger.grouphouse.forEach((element) => {
    //           // console.log(element)
    //           if (element.house_type_id == val.house_type_id) {
    //             this.filterGroup.push(ger);
    //             this.showGroup = this.filterGroup[0];
    //             // console.log(this.showGroup,'showgroupssss')
    //           }
    //         });
    //       });
    //     } else {
    //       this.HOUSE_TYPE_GROUPS.filter((ger) => {
    //         ger.grouphouse.forEach((element) => {
    //           if (element.house_type_id == val.house_type_id['id']) {
    //             this.filterGroup.push(ger);
    //             this.showGroup = this.filterGroup[0];
    //             // console.log(this.showGroup,'showgroupssss')
    //           } else if (element.house_type_id == val.house_type_id) {
    //             this.filterGroup.push(ger);
    //             this.showGroup = this.filterGroup[0];
    //           }
    //         });
    //       });
    //     }

    //     // KANABAKARI(240,260,265) IN EVERY HOUSE TYPE ID 
    //     if(this.cadRequestBasicInformation != 0) {
    //       this.KANABAKARI_SETTINGS.filter((kana) => {
    //       // console.log(kana,'kanaaaa')
    //         kana.kanahousetype.forEach((elementx) => {
    //           // console.log(elementx,'elementx')
    //           if (elementx.house_type_id == val.house_type_id) {
    //             this.sortKanabakari.push(kana);
    //             // console.log(this.sortKanabakari,'sortKanabakari')
    //           }
    //         });
    //     });
    //     } else {
    //       this.KANABAKARI_SETTINGS.filter((kana) => {
    //         kana.kanahousetype.forEach((elementz) => {
    //           if(elementz.house_type_id == val.house_type_id['id']){
    //             this.sortKanabakari.push(kana);
    //             // console.log(this.sortKanabakari,'sortKanabakari')
    //           } else if (elementz.house_type_id == val.house_type_id){
    //             this.sortKanabakari.push(kana);
    //           }
    //         });
    //       });
    //     }
    //     // GET 240, 260+ nd 265 in database and it will show it dependes on the master settings you set up
    //     this.sortKanabakari.filter((vo) => {
    //       this.kanaSetting.push(vo.kanabakari_name);
    //       // console.log(vo.kanabakari_name, 'kanabakari_name')
    //     });
    //   }

    //   this.sortRemarks = [];
    //   if (val.house_type_id) {
    //     this.HOUSE_TYPE_REMARKS.filter((din) => {
    //       // console.log(din.id, val.house_type_id)
    //       if (din.id == val.house_type_id) {
    //         din.remarks.filter((r) => {
    //           this.sortRemarks.push(r);
    //         });
    //       }
    //     });
    //   }
    //   // THIS WILL SHOW SAVE REMARKS IN CAD BASIC INFO REMARKS
    //   val.remarks = this.cadRequestBasicInformationRemarks.filter((cadrem) => {
    //     return (
    //       cadrem.house_type_id === val.house_type_id &&
    //       cadrem.basic_information_id === val.id
    //     );
    //   });
    //   // console.log(val.remarks, 'val.remarks')

    //   // GET GC CONTROL NUMBER IN CAD BASIC INFO REMARKS
    //   this.getSiyo = val.remarks.filter((mvp) => {
    //     return mvp.gc_control_number;
    //   });
    //   val.gc_control_number =
    //     this.getSiyo[0] != null ? this.getSiyo[0].gc_control_number : null;

    //   // GET SNOW VALUE IN CAD BASIC INFO REMARKS
    //   this.getSnow = val.remarks.filter((isnow) => {
    //     return isnow.snow;
    //   });
    //   val.snow = this.getSnow[0] != null ? this.getSnow[0].snow : null;

    //   // console.log(this.getSnow,'getSnow')

    //   // console.log(getSiyo[0].gc_control_number,'getSiyo')

    //   // JYUNTAIKA
    //   if (val.house_type_id === 3 || val.house_type_id === 29 
    //     || val.house_type_id === 22 || val.house_type_id === 23) {
    //     this.getFireProtection = this.fireProtectionList.filter(item => item.value !== '3');
    //   } else {
    //     this.getFireProtection =  this.fireProtectionList;
    //   }

    // },

    // NEW 20260401
    tempData(val) {
      if (!val) return;

      if (val.house_type_id) {
        const idsToNullify = [1, 4, 5, 6, 9, 11];
        let currentId = (typeof val.house_type_id === 'object') ? val.house_type_id.id : val.house_type_id;
        
        if (idsToNullify.includes(Number(currentId))) {
          val.house_type_id = null;
        }
      }

      this.filterGroup = [];
      this.sortKanabakari = [];
      this.kanaSetting = [];

      if (val.house_type_id) {
        // DYNAMICALLY SHOW FIRE PROTECTION, etc.
        if (this.cadRequestBasicInformation != 0) {
          this.HOUSE_TYPE_GROUPS.forEach((ger) => {
            ger.grouphouse.forEach((element) => {
              if (element.house_type_id == val.house_type_id) {
                this.filterGroup.push(ger);
                this.showGroup = this.filterGroup[0];
              }
            });
          });
        } else {
          this.HOUSE_TYPE_GROUPS.forEach((ger) => {
            ger.grouphouse.forEach((element) => {
              let checkId = val.house_type_id['id'] ? val.house_type_id['id'] : val.house_type_id;
              if (element.house_type_id == checkId) {
                this.filterGroup.push(ger);
                this.showGroup = this.filterGroup[0];
              }
            });
          });
        }

        // KANABAKARI SETTINGS
        const kanaSource = this.KANABAKARI_SETTINGS;
        kanaSource.forEach((kana) => {
          kana.kanahousetype.forEach((element) => {
            let checkId = (typeof val.house_type_id === 'object') ? val.house_type_id.id : val.house_type_id;
            if (element.house_type_id == checkId) {
              this.sortKanabakari.push(kana);
            }
          });
        });

        this.sortKanabakari.forEach((vo) => {
          this.kanaSetting.push(vo.kanabakari_name);
        });
      }

      this.sortRemarks = [];
      if (val.house_type_id) {
        this.HOUSE_TYPE_REMARKS.forEach((din) => {
          if (din.id == val.house_type_id) {
            din.remarks.forEach((r) => this.sortRemarks.push(r));
          }
        });
      }

      val.remarks = this.cadRequestBasicInformationRemarks.filter((cadrem) => {
        return (
          cadrem.house_type_id === val.house_type_id &&
          cadrem.basic_information_id === val.id
        );
      });

      this.getSiyo = val.remarks.filter((mvp) => mvp.gc_control_number);
      val.gc_control_number = this.getSiyo[0] ? this.getSiyo[0].gc_control_number : null;

      this.getSnow = val.remarks.filter((isnow) => isnow.snow);
      val.snow = this.getSnow[0] ? this.getSnow[0].snow : null;

      const jyuntaikaIds = [3, 29, 22, 23];
      if (val.house_type_id && jyuntaikaIds.includes(Number(val.house_type_id))) {
        this.getFireProtection = this.fireProtectionList.filter(item => item.value !== '3');
      } else {
        this.getFireProtection = this.fireProtectionList;
      }
    }

  },
  // "$store.state.cadRequestBasicInformation"(val) {
    // let arr = []
    // arr.push(val);
    // if(arr.length > 0){
    // 	this.$store.state.cadRequestBasicInformation = arr.map((r) => {
    // 		if(r.customer_name){
    // 			if(r.customer_name.includes(" ")){
    // 				r.customer_name = r.customer_name.split(" ")[0];
    // 			}else if(r.customer_name.includes("　")){
    // 				r.customer_name = r.customer_name.split("　")[0];
    // 			}
    // 		}
    // 		return r;
    // 	})
    // }
  // },
  "$store.state.cadRequestRevisionContent"(val) {
    // console.log(val,'aaaaa')
  },

  "$store.state.existingRevisions"(val) {
    if (val) {
      this.floatButtons.cadPdf = true;
      this.floatButtons.piraPdf = true;
    }
  },
};
</script>

<style scoped>
.custom-text-field .v-input__control {
  height: 40px;
}

.custom-snackbar {
  margin-top: 25%;
}
.centered-div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}
</style>
